
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("d1p2I", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $abC4X = parcelRequire("abC4X");


var $gdv5Z = parcelRequire("gdv5Z");


var $5dK2X = parcelRequire("5dK2X");





var $40RQI = parcelRequire("40RQI");

const $1fbb045fdeaef17c$export$f370712d0ce7173b = ()=>{
    const theme = (0, $40RQI.useColorMode)();
    const isDarkTheme = theme === 'dark';
    const fillColour = isDarkTheme ? '#4B4D51' : '#DDDEE1';
    const innerColour = isDarkTheme ? '#101214' : 'white';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        "data-testid": "navigation-empty-state--generic-error-icon",
        width: "57",
        height: "53",
        viewBox: "0 0 57 53",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 52.5871L0.0314182 52.6499H56.8739L56.9088 52.5871L28.4544 0L0 52.5871Z",
        fill: fillColour,
        "data-vc": "k6HJ8Y0F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.2725 38.0368V18.8333H29.8313V38.0368H27.2725Z",
        fill: innerColour
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.0814 41.2098C28.2675 41.1764 28.4451 41.1665 28.5973 41.1665C28.7583 41.1665 28.9179 41.1777 29.0781 41.2023L29.084 41.2032L29.0899 41.2042C30.1047 41.37 30.9494 42.0762 31.154 43.2046C31.19 43.3958 31.1998 43.5794 31.1998 43.7306C31.1998 43.8478 31.1939 43.9799 31.1754 44.1197V44.1412L31.1552 44.2533C30.9533 45.3786 30.1106 46.0937 29.0899 46.2604L29.084 46.2614L29.0781 46.2623C28.9179 46.287 28.7583 46.2981 28.5973 46.2981C28.444 46.2981 28.2649 46.2881 28.0772 46.2541C27.0757 46.0805 26.2351 45.3807 26.0303 44.2574C25.9948 44.0692 25.9844 43.8932 25.9844 43.7341C25.9844 43.5767 25.9945 43.3951 26.0311 43.2033C26.2382 42.0971 27.0613 41.3814 28.0814 41.2098ZM28.5432 43.7274C28.5432 43.7295 28.5432 43.7318 28.5432 43.7341C28.5432 43.7352 28.5432 43.7362 28.5432 43.7373C28.5444 43.7374 28.5456 43.7375 28.547 43.7376C28.559 43.7385 28.5757 43.7393 28.5973 43.7393C28.6137 43.7393 28.6281 43.7389 28.6409 43.7381C28.6409 43.7357 28.641 43.7332 28.641 43.7306C28.641 43.7292 28.641 43.7278 28.6409 43.7265C28.6282 43.7258 28.6137 43.7253 28.5973 43.7253C28.5757 43.7253 28.559 43.7261 28.547 43.727C28.5457 43.7272 28.5444 43.7273 28.5432 43.7274Z",
        fill: innerColour
    }));
};


const $d562a938958ff7a0$var$styles = {
    textWrapper: "_195g1wug _p12fo8uj _1e0c1o8l",
    imageWrapper: "_n3td1jfw"
};
function $d562a938958ff7a0$export$618cc98292cae482({ testId: testId = 'navigation-empty-state', renderImage: renderImage = ()=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $d562a938958ff7a0$var$styles.imageWrapper
    }, /*#__PURE__*/ $42omo.createElement((0, $1fbb045fdeaef17c$export$f370712d0ce7173b), null)), description: description, ...restProps }) {
    return /*#__PURE__*/ $42omo.createElement((0, $abC4X.default), {
        ...restProps,
        testId: testId,
        renderImage: renderImage,
        headingLevel: 3,
        headingSize: "xsmall",
        description: /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                $d562a938958ff7a0$var$styles.textWrapper
            ]),
            "data-vc": "P_oFkx4D"
        }, /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
            size: "small",
            color: "color.text.subtle"
        }, description))
    });
}
module.exports["NavEmptyState"] = $d562a938958ff7a0$export$618cc98292cae482;

});

parcelRegister("dBtY8", function(module, exports) {
/**
 * Constants representing locations within the navigation system where errors might occur.
 * These help in identifying the source of errors for logging and debugging purposes.
 */ const $62b96c634929dcc9$export$98b0f7a0d3bb5010 = 'customization-modal';
const $62b96c634929dcc9$export$980ebe5373108eff = 'drag-and-drop';
const $62b96c634929dcc9$export$1cb3fe63ec81f460 = 'global-shortcuts';
const $62b96c634929dcc9$export$29208be8b6408bd4 = 'global-side-navigation';
const $62b96c634929dcc9$export$649c709379c80e01 = 'global-side-navigation-item';
const $62b96c634929dcc9$export$46aed26dfad8c2b0 = 'gsn-main-nav-item';
const $62b96c634929dcc9$export$7b1d5fb8b81e96a9 = 'ribbon';
module.exports["ERROR_LOCATION__CUSTOMIZATION_MODAL"] = $62b96c634929dcc9$export$98b0f7a0d3bb5010;
module.exports["ERROR_LOCATION__DRAG_AND_DROP"] = $62b96c634929dcc9$export$980ebe5373108eff;
module.exports["ERROR_LOCATION__GLOBAL_SHORTCUTS"] = $62b96c634929dcc9$export$1cb3fe63ec81f460;
module.exports["ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION"] = $62b96c634929dcc9$export$29208be8b6408bd4;
module.exports["ERROR_LOCATION__GSN_NAV_ITEM_ACTIONS"] = $62b96c634929dcc9$export$649c709379c80e01;
module.exports["ERROR_LOCATION__GSN_MAIN_NAV_ITEM"] = $62b96c634929dcc9$export$46aed26dfad8c2b0;

});

parcelRegister("5xxOu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");

// TODO(navx-4866-migrate-messages-from-nav-error-boundary): This entire file,
// along with async-languages.ts and the src/i18n/ translation files, can be
// deleted once the gate is cleaned up — at that point AsyncIntlProvider is no
// longer mounted by NavErrorBoundary and this locale infrastructure is unused.




var $keVvA = parcelRequire("keVvA");


var $eB7BJ = parcelRequire("eB7BJ");

// https://parceljs.org/features/dependency-resolution/#glob-specifiers




























const $c667adb400559b66$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("4AVTD")),
    da: ()=>(parcelRequire("k4Ine")),
    de: ()=>(parcelRequire("7YRaF")),
    'en-GB': ()=>(parcelRequire("iVnJf")),
    'en-ZZ': ()=>(parcelRequire("kmblI")),
    en: ()=>Promise.resolve((parcelRequire("eB7BJ"))),
    es: ()=>(parcelRequire("jPeNE")),
    fi: ()=>(parcelRequire("gzopq")),
    fr: ()=>(parcelRequire("aL5By")),
    hr: ()=>(parcelRequire("9qoF1")),
    hu: ()=>(parcelRequire("gqVWX")),
    it: ()=>(parcelRequire("jSq5F")),
    ja: ()=>(parcelRequire("j29KS")),
    ko: ()=>(parcelRequire("bwCVT")),
    nb: ()=>(parcelRequire("gTSL0")),
    // nl: () =>
    // 	import(
    // 		/* webpackChunkName: "@atlaskit-internal_@atlassian/navigation-error-boundary-i18n-nl" */ '../../../i18n/nl'
    // 	),
    pl: ()=>(parcelRequire("9qC4p")),
    'pt-BR': ()=>(parcelRequire("5oI7Y")),
    ru: ()=>(parcelRequire("hFpC3")),
    sl: ()=>(parcelRequire("gOPix")),
    'sr-RS': ()=>(parcelRequire("8BBUz")),
    'sr-YR': ()=>(parcelRequire("Qg6FR")),
    sv: ()=>(parcelRequire("9ehaJ")),
    th: ()=>(parcelRequire("kJgzR")),
    tr: ()=>(parcelRequire("1m6Vi")),
    uk: ()=>(parcelRequire("8X2Nj")),
    vi: ()=>(parcelRequire("64h8l")),
    zh_TW: ()=>(parcelRequire("gkyBQ")),
    zh: ()=>(parcelRequire("3BiPW"))
};


// Sentinel context: true means an IntlMessagesProvider is already mounted in a parent
const $c5e5f2aa3b0d680d$var$AsyncIntlProviderMountedContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(false);
function $c5e5f2aa3b0d680d$export$2f688dfcc031530a({ children: children }) {
    const alreadyMounted = (0, $42omo.useContext)($c5e5f2aa3b0d680d$var$AsyncIntlProviderMountedContext);
    // If a parent NavErrorBoundary already mounted the provider, skip the redundant fetch.
    if (alreadyMounted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5e5f2aa3b0d680d$var$AsyncIntlProviderMountedContext.Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
        defaultMessages: (0, $eB7BJ.default),
        loaderFn: $c5e5f2aa3b0d680d$var$fetchMessagesForLocale
    }, children));
}
async function $c5e5f2aa3b0d680d$var$fetchMessagesForLocale(locale) {
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $c667adb400559b66$export$3770c7a7737d463c) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $c667adb400559b66$export$3770c7a7737d463c)[languageLocale]?.();
        return localeMessages?.default ?? (0, $eB7BJ.default);
    } catch  {
    // ignore
    }
    return 0, $eB7BJ.default;
}



var $5IDSL = parcelRequire("5IDSL");








var $dBtY8 = parcelRequire("dBtY8");


var $aXWIB = parcelRequire("aXWIB");

const $797668988538d21a$export$628f6f7219a6b8b6 = (0, $aXWIB.defineMessages)({
    header: {
        id: "navigation.error.header.default",
        defaultMessage: "We couldn\u2019t load this content"
    },
    description: {
        id: "navigation.error.description.default",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$8587940f17f4d26 = (0, $aXWIB.defineMessages)({
    header: {
        id: "navigation.error.header.customization-modal",
        defaultMessage: "We couldn\u2019t load your customization options"
    },
    description: {
        id: "navigation.error.description.customization-modal",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$9483ff6124cf0a32 = (0, $aXWIB.defineMessages)({
    header: {
        id: "navigation.error.header.global-side-navigation",
        defaultMessage: "We couldn\u2019t load the sidebar"
    },
    description: {
        id: "navigation.error.description.global-side-navigation",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$18eaee65a8fa9237 = (0, $aXWIB.defineMessages)({
    header: {
        id: "navigation.error.header.global-side-navigation-nav-item-actions",
        defaultMessage: "We couldn\u2019t load more actions"
    },
    description: {
        id: "navigation.error.description.global-side-navigation-nav-item-actions",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$a8585c3005ff8118 = (0, $aXWIB.defineMessages)({
    header: {
        id: "navigation.error.ui.header.drag-and-drop",
        defaultMessage: "We couldn\u2019t complete this action"
    },
    description: {
        id: "navigation.error.ui.description.drag-and-drop",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$60436671aeff828f = (0, $aXWIB.defineMessages)({
    header: {
        id: "navigation.error.header.global-shortcuts",
        defaultMessage: "We couldn\u2019t load the app {uuId}"
    },
    description: {
        id: "navigation.error.description.global-shortcuts",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$4e37cb57ad07debd = (0, $aXWIB.defineMessages)({
    header: {
        id: "navigation.error.header.gsn-main-nav-item",
        defaultMessage: "We couldn\u2019t load the item {uuId}"
    },
    description: {
        id: "navigation.error.description.gsn-main-nav-item",
        defaultMessage: "Refresh the page and try again"
    }
});


function $03436e25535634a1$export$3331c7144beb2006(location) {
    const [baseLocation, uuId] = location?.split('--') || [];
    switch(baseLocation){
        case 0, $dBtY8.ERROR_LOCATION__CUSTOMIZATION_MODAL:
            return 0, $797668988538d21a$export$8587940f17f4d26;
        // Not used!
        case 0, $dBtY8.ERROR_LOCATION__DRAG_AND_DROP:
            return 0, $797668988538d21a$export$a8585c3005ff8118;
        case 0, $dBtY8.ERROR_LOCATION__GLOBAL_SHORTCUTS:
            return {
                ...(0, $797668988538d21a$export$60436671aeff828f),
                values: {
                    uuId: uuId
                }
            };
        case 0, $dBtY8.ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION:
            return 0, $797668988538d21a$export$9483ff6124cf0a32;
        case 0, $dBtY8.ERROR_LOCATION__GSN_NAV_ITEM_ACTIONS:
            return 0, $797668988538d21a$export$18eaee65a8fa9237;
        case 0, $dBtY8.ERROR_LOCATION__GSN_MAIN_NAV_ITEM:
            return {
                ...(0, $797668988538d21a$export$4e37cb57ad07debd),
                values: {
                    uuId: uuId
                }
            };
        default:
            return 0, $797668988538d21a$export$628f6f7219a6b8b6;
    }
}


function $48eff3d58eb501ee$export$8c20ab16ac9cf14f({ errorMessages: errorMessages, errorMessageValues: errorMessageValues, location: location }) {
    return errorMessages ? {
        header: errorMessages.header,
        description: errorMessages.description,
        values: errorMessageValues
    } : (0, $03436e25535634a1$export$3331c7144beb2006)(location);
}



function $75bd583a9ee37537$export$dd28f26aa5199f5({ errorMessages: errorMessages, errorMessageValues: errorMessageValues, location: location }) {
    return (0, $42omo.useMemo)(()=>{
        return (0, $dh538.fg)('navx-4866-migrate-messages-from-nav-error-boundary') ? (0, $48eff3d58eb501ee$export$8c20ab16ac9cf14f)({
            errorMessages: errorMessages,
            errorMessageValues: errorMessageValues,
            location: location
        }) : (0, $03436e25535634a1$export$3331c7144beb2006)(location);
    }, [
        location,
        errorMessages,
        errorMessageValues
    ]);
}











function $55ca36f58444f28e$export$bc7f29bc4d00b60a(flags) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isReemitFlagEnabled = (0, $dh538.fg)('navx-4866-migrate-messages-from-nav-error-boundary');
    const pendingFlagRef = (0, $42omo.useRef)(null);
    const dismissPendingFlagRef = (0, $42omo.useRef)(null);
    const reEmitPendingFlag = (0, $42omo.useCallback)(()=>{
        const pending = pendingFlagRef.current;
        if (!flags || !pending) return;
        dismissPendingFlagRef.current?.();
        const dismiss = flags.showFailure({
            title: formatMessage(pending.header, pending.values),
            description: formatMessage(pending.description, pending.values)
        });
        dismissPendingFlagRef.current = typeof dismiss === 'function' ? dismiss : null;
    }, [
        flags,
        formatMessage
    ]);
    // Re-emit whenever `formatMessage` identity changes (i.e. the inner
    // IntlProvider has re-rendered with a new messages map after the async
    // load). No-op when the gate is OFF or no error has fired yet.
    (0, $42omo.useEffect)(()=>{
        if (!isReemitFlagEnabled) return;
        if (pendingFlagRef.current) reEmitPendingFlag();
    }, [
        reEmitPendingFlag,
        isReemitFlagEnabled
    ]);
    // On unmount, dismiss any flag we own so we don't leak it into the host
    // app's FlagGroup after this boundary goes away.
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            dismissPendingFlagRef.current?.();
            dismissPendingFlagRef.current = null;
            pendingFlagRef.current = null;
        };
    }, []);
    return (0, $42omo.useCallback)((pending)=>{
        if (isReemitFlagEnabled) {
            // Capture the descriptor inputs so the locale-change effect can
            // re-emit a re-localised flag once messages finish loading.
            // Emit immediately (possibly in the default language) so the
            // user gets visible feedback right away.
            pendingFlagRef.current = pending;
            reEmitPendingFlag();
        } else // Legacy behaviour: single emission, may be in the default
        // language if the async messages loader hasn't resolved yet
        // (see NAVX-5012).
        flags?.showFailure?.({
            title: formatMessage(pending.header, pending.values),
            description: formatMessage(pending.description, pending.values)
        });
    }, [
        isReemitFlagEnabled,
        reEmitPendingFlag,
        flags,
        formatMessage
    ]);
}









var $7yDmn = parcelRequire("7yDmn");

function $a32d3e2214df8275$export$ad59d437e6db3634({ showFlags: showFlags = false }) {
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const flags = (0, $42omo.useMemo)(()=>({
            showFailure: ({ title: title, description: description, actions: actions })=>{
                return showFlag({
                    actions: actions,
                    description: description,
                    id: $a32d3e2214df8275$var$flagsIds.failure,
                    isAutoDismiss: true,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                        label: "Failure",
                        spacing: "spacious"
                    }),
                    testId: $a32d3e2214df8275$var$flagsIds.failure,
                    title: title
                });
            }
        }), [
        showFlag
    ]);
    return !showFlags ? undefined : flags;
}
const $a32d3e2214df8275$var$flagsIds = {
    failure: 'nav-error-boundary-failure-flag'
};






var $eduVw = parcelRequire("eduVw");


var $4rFRN = parcelRequire("4rFRN");

function $f2067de35833dca2$export$2139d636391467cf({ interactionId: interactionId, ufoInteractionName: ufoInteractionName }) {
    const reportError = (0, $eduVw.useUFOReportError)();
    const reportErrorRef = (0, $42omo.useRef)(reportError);
    reportErrorRef.current = reportError;
    return (0, $42omo.useCallback)((error)=>{
        const name = ufoInteractionName ? ufoInteractionName : interactionId ? (0, $4rFRN.NavigationExperienceId)[interactionId].experienceId : undefined;
        if (!name) return;
        reportErrorRef.current({
            name: name,
            errorMessage: error.message,
            errorStack: error.stack,
            errorStatusCode: error instanceof Response ? error?.status : undefined
        });
    }, [
        interactionId,
        ufoInteractionName
    ]);
}









var $d1p2I = parcelRequire("d1p2I");


var $4NsV7 = parcelRequire("4NsV7");


function $08962ae18cab1bac$export$ed65a7143a39e5b6({ disableAnalytics: disableAnalytics, errorFallbackUI: errorFallbackUI, errorActionUI: errorActionUI, location: location, errorMessages: errorMessages, errorMessageValues: errorMessageValues }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { fireEvent: fireEvent } = (0, $4NsV7.useAnalyticsEvents)();
    // Message precedence: errorMessages (consumer-provided) > location-based lookup
    const { header: header, description: description, values: values } = (0, $48eff3d58eb501ee$export$8c20ab16ac9cf14f)({
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues,
        location: location
    });
    (0, $42omo.useLayoutEffect)(()=>{
        if (!disableAnalytics) fireEvent('ui.errorBoundary.viewed.errorBoundaryUI', {
            location: location,
            isFallbackUI: !!errorFallbackUI
        });
    }, [
        disableAnalytics,
        errorFallbackUI,
        fireEvent,
        location
    ]);
    // If a custom fallback UI is provided, render it directly at risk of consumer
    if (errorFallbackUI) return errorFallbackUI({
        header: formatMessage(header, values),
        description: formatMessage(description, values)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d1p2I.NavEmptyState), {
        testId: "navigation-error-boundary-ui",
        header: formatMessage(header, values),
        description: formatMessage(description, values),
        primaryAction: errorActionUI
    });
}


function $4c2fb4ef44ce22b7$export$afc779e659fd533f(props) {
    const { UNSAFE_wrapper: UNSAFE_wrapper, intlMode: intlMode = 'async' } = props;
    const WrapperComponent = (0, $42omo.useMemo)(()=>UNSAFE_wrapper && (0, $dh538.fg)('navx-gsn-dnc-ownership-marker') ? UNSAFE_wrapper : (0, $42omo.Fragment), [
        UNSAFE_wrapper
    ]);
    const IntlWrapper = intlMode === 'inherit' || (0, $dh538.fg)('navx-4866-migrate-messages-from-nav-error-boundary') ? (0, $42omo.Fragment) : (0, $c5e5f2aa3b0d680d$export$2f688dfcc031530a);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IntlWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c2fb4ef44ce22b7$var$InnerErrorBoundary, props))));
}
function $4c2fb4ef44ce22b7$var$InnerErrorBoundary({ disableAnalytics: disableAnalytics = false, disableSentry: disableSentry = false, errorActionUI: errorActionUI, errorFallbackUI: errorFallbackUI, errorMessages: errorMessages, errorMessageValues: errorMessageValues, interactionId: interactionId, location: location = 'unknown', onError: onError, showFlags: showFlags, silent: silent, children: children, sentryConfig: sentryConfig, tags: tags, ufoInteractionName: ufoInteractionName }) {
    const { header: header, description: description, values: values } = (0, $75bd583a9ee37537$export$dd28f26aa5199f5)({
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues,
        location: location
    });
    const flags = (0, $a32d3e2214df8275$export$ad59d437e6db3634)({
        showFlags: showFlags
    });
    const emitFailureFlag = (0, $55ca36f58444f28e$export$bc7f29bc4d00b60a)(flags);
    const reportInteractionError = (0, $f2067de35833dca2$export$2139d636391467cf)({
        interactionId: interactionId,
        ufoInteractionName: ufoInteractionName
    });
    const onErrorUIHandler = (0, $42omo.useCallback)((error)=>{
        emitFailureFlag({
            header: header,
            description: description,
            values: values
        });
        reportInteractionError(error);
        onError?.(error);
    }, [
        emitFailureFlag,
        reportInteractionError,
        header,
        description,
        values,
        onError
    ]);
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)({
        disableAnalytics: disableAnalytics,
        disableSentry: disableSentry,
        interactionId: interactionId,
        location: location,
        onError: onErrorUIHandler,
        sentryConfig: sentryConfig,
        tags: tags
    });
    // When `silent` is true or `flags` are enabled, we don't want to show any UI on error
    const errorComponent = silent || flags ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $08962ae18cab1bac$export$ed65a7143a39e5b6), {
        disableAnalytics: disableAnalytics,
        errorActionUI: errorActionUI,
        errorFallbackUI: errorFallbackUI,
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues,
        location: location
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        onError: handleError,
        fallback: errorComponent
    }, children);
}
module.exports["NavErrorBoundary"] = $4c2fb4ef44ce22b7$export$afc779e659fd533f;

});

parcelRegister("eB7BJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d4d83780c7949fa7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $40c8554630cee504$export$2e2bcd8739ae039 = {
    'navigation.error.description.customization-modal': 'Refresh the page and try again',
    'navigation.error.description.default': 'Refresh the page and try again',
    'navigation.error.description.global-more-menu': 'Refresh the page and try again',
    'navigation.error.description.global-more-menu-item': 'Refresh the page and try again',
    'navigation.error.description.global-shortcuts': 'Refresh the page and try again',
    'navigation.error.description.global-side-navigation': 'Refresh the page and try again',
    'navigation.error.description.global-side-navigation-nav-item-actions': 'Refresh the page and try again',
    'navigation.error.description.gsn-main-nav-item': 'Refresh the page and try again',
    'navigation.error.header.customization-modal': "We couldn\u2019t load your customization options",
    'navigation.error.header.default': "We couldn\u2019t load this content",
    'navigation.error.header.global-more-menu': "We couldn\u2019t load more options",
    'navigation.error.header.global-more-menu-item': "We couldn\u2019t load {uuId} in more options",
    'navigation.error.header.global-shortcuts': "We couldn\u2019t load the app {uuId}",
    'navigation.error.header.global-side-navigation': "We couldn\u2019t load the sidebar",
    'navigation.error.header.global-side-navigation-nav-item-actions': "We couldn\u2019t load more actions",
    'navigation.error.header.gsn-main-nav-item': "We couldn\u2019t load the item {uuId}",
    'navigation.error.ui.description.drag-and-drop': 'Refresh the page and try again',
    'navigation.error.ui.header.drag-and-drop': "We couldn\u2019t complete this action"
};


var $d4d83780c7949fa7$export$2e2bcd8739ae039 = (0, $40c8554630cee504$export$2e2bcd8739ae039);

});

parcelRegister("4AVTD", function(module, exports) {

let $35876f3524946fc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35876f3524946fc1$var$load("d4ByE").then(()=>parcelRequire('a4nWN'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("k4Ine", function(module, exports) {

let $e9d69a15e3f94393$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9d69a15e3f94393$var$load("5hSoy").then(()=>parcelRequire('3Fkcb'));

});

parcelRegister("7YRaF", function(module, exports) {

let $5cf761aca73998e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5cf761aca73998e6$var$load("7VsjH").then(()=>parcelRequire('uLMk8'));

});

parcelRegister("iVnJf", function(module, exports) {

let $dc6ff4ed35144d3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc6ff4ed35144d3c$var$load("a268B").then(()=>parcelRequire('9bFeu'));

});

parcelRegister("kmblI", function(module, exports) {

let $ed1eaa6cdadcf8e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ed1eaa6cdadcf8e6$var$load("lhSi1").then(()=>parcelRequire('kJOzS'));

});

parcelRegister("jPeNE", function(module, exports) {

let $e6ee42ac2282811f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6ee42ac2282811f$var$load("ft9Ll").then(()=>parcelRequire('dv9cK'));

});

parcelRegister("gzopq", function(module, exports) {

let $c102d958a33629d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c102d958a33629d1$var$load("jTa87").then(()=>parcelRequire('guy58'));

});

parcelRegister("aL5By", function(module, exports) {

let $7d52a42594142cfc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d52a42594142cfc$var$load("aNiGa").then(()=>parcelRequire('ksVsc'));

});

parcelRegister("9qoF1", function(module, exports) {

let $6dc9abde5dd1422f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dc9abde5dd1422f$var$load("4r8Lc").then(()=>parcelRequire('5Ce6L'));

});

parcelRegister("gqVWX", function(module, exports) {

let $bf6c06af68a1f87f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf6c06af68a1f87f$var$load("hgY73").then(()=>parcelRequire('kb6NW'));

});

parcelRegister("jSq5F", function(module, exports) {

let $e7874c794a3d4bb3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7874c794a3d4bb3$var$load("dlCkw").then(()=>parcelRequire('eO4ch'));

});

parcelRegister("j29KS", function(module, exports) {

let $ddb5c55edcd44f28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ddb5c55edcd44f28$var$load("l9GjK").then(()=>parcelRequire('fwmUv'));

});

parcelRegister("bwCVT", function(module, exports) {

let $8640e2173d4bc27d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8640e2173d4bc27d$var$load("fz30M").then(()=>parcelRequire('jU4cW'));

});

parcelRegister("gTSL0", function(module, exports) {

let $c4dc4202454ae5d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4dc4202454ae5d6$var$load("kALI0").then(()=>parcelRequire('hClVv'));

});

parcelRegister("9qC4p", function(module, exports) {

let $6dd412aba2dfa617$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dd412aba2dfa617$var$load("JRBbC").then(()=>parcelRequire('jYcr9'));

});

parcelRegister("5oI7Y", function(module, exports) {

let $3ee16c760a830f7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ee16c760a830f7c$var$load("9eERo").then(()=>parcelRequire('57dQu'));

});

parcelRegister("hFpC3", function(module, exports) {

let $cdca2226e651accf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cdca2226e651accf$var$load("9kBhC").then(()=>parcelRequire('blWCR'));

});

parcelRegister("gOPix", function(module, exports) {

let $c3e91b8f399b2bcd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3e91b8f399b2bcd$var$load("bzIZv").then(()=>parcelRequire('15Tpv'));

});

parcelRegister("8BBUz", function(module, exports) {

let $643f2fd6bd274a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $643f2fd6bd274a01$var$load("ab9gs").then(()=>parcelRequire('g2vDV'));

});

parcelRegister("Qg6FR", function(module, exports) {

let $09d159e3668e805c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09d159e3668e805c$var$load("awEHL").then(()=>parcelRequire('9jpbR'));

});

parcelRegister("9ehaJ", function(module, exports) {

let $6b82bde1e08509aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b82bde1e08509aa$var$load("d0TBI").then(()=>parcelRequire('dxZc6'));

});

parcelRegister("kJgzR", function(module, exports) {

let $f174de86bfa0e7f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f174de86bfa0e7f0$var$load("44Tsr").then(()=>parcelRequire('aYhka'));

});

parcelRegister("1m6Vi", function(module, exports) {

let $0fcd3753fb562f68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0fcd3753fb562f68$var$load("52Fkw").then(()=>parcelRequire('7Xh53'));

});

parcelRegister("8X2Nj", function(module, exports) {

let $6846005456532c80$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6846005456532c80$var$load("15Ksq").then(()=>parcelRequire('iniEE'));

});

parcelRegister("64h8l", function(module, exports) {

let $46b068291a809bb5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46b068291a809bb5$var$load("7uvuw").then(()=>parcelRequire('5jale'));

});

parcelRegister("gkyBQ", function(module, exports) {

let $be395c4d4375c70e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be395c4d4375c70e$var$load("8j70M").then(()=>parcelRequire('jf30t'));

});

parcelRegister("3BiPW", function(module, exports) {

let $29f3706877351e56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29f3706877351e56$var$load("7d6QX").then(()=>parcelRequire('eRE7P'));

});

parcelRegister("gcpE0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");

function $074048dba8acb01e$export$6fa362ed4e835606({ defaultMessages: defaultMessages, asyncLanguages: asyncLanguages, onLoadError: onLoadError }) {
    const fetchMessagesForLocale = async (locale)=>{
        try {
            // Fallback to the generic locale (e.g. `de`) if the specified
            // region-qualified locale (e.g. `de-DE`) is not present in the map.
            const languageLocale = locale in asyncLanguages ? locale : locale.split(/[-_]/)[0] || '';
            const localeMessages = await asyncLanguages[languageLocale]?.();
            return localeMessages?.default ?? defaultMessages;
        } catch (e) {
            onLoadError?.(locale, e);
        }
        return defaultMessages;
    };
    return function AsyncIntlProvider({ children: children, disabled: disabled = false }) {
        if (disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        // `fetchMessagesForLocale` is defined once at factory-call time and
        // closed over here, so its identity is already stable across renders
        // of this returned component — no `useCallback` needed.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
            defaultMessages: defaultMessages,
            loaderFn: fetchMessagesForLocale
        }, children);
    };
}
module.exports["createAsyncIntlProvider"] = $074048dba8acb01e$export$6fa362ed4e835606;

});

parcelRegister("lchQJ", function(module, exports) {
/**
 * @generated SignedSource<<e74d1f766145cf278c40971759c0b85d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bb57c3f63422c4cb$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "productType"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "useGlobalShortcutsDataRelay",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "LinkedField",
                "name": "appSwitcher_availableProductsBySite",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "products",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ 
                                        ],
                                        "type": "AppSwitcherSingleUrlProduct"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "concreteType": "AppSwitcherProductSite",
                                                "kind": "LinkedField",
                                                "name": "sites",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "siteId"
                                                    },
                                                    v2 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "AppSwitcherSiteScopedProduct"
                                    }
                                ]
                            }
                        ],
                        "type": "AppSwitcherAvailableProductsBySite"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "QueryError"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$bb57c3f63422c4cb$var$node.hash = "c8b29534eaae104f3d284f0f36fda276";
var $bb57c3f63422c4cb$export$2e2bcd8739ae039 = $bb57c3f63422c4cb$var$node;



var $42omo = parcelRequire("42omo");


var $hwDTW = parcelRequire("hwDTW");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $culkJ = parcelRequire("culkJ");

const $db75f94d1973e895$export$2dc34b66082250f3 = ({ queryRef: queryRef, cloudId: cloudId, onError: onError, shortcutsConfig: shortcutsConfig, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks })=>{
    const onUpdateGetFilteredProductLinksRef = (0, $42omo.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    /* eslint-disable @atlassian/relay/graphql-naming */ /* eslint-disable @atlassian/relay/no-wrapping-hooks */ const fragmentData = (0, $irOoi.useFragment)((0, $bb57c3f63422c4cb$export$2e2bcd8739ae039), queryRef);
    /* eslint-enable @atlassian/relay/graphql-naming */ /* eslint-enable @atlassian/relay/no-wrapping-hooks */ const appSwitcherResult = fragmentData?.appSwitcher_availableProductsBySite;
    (0, $42omo.useEffect)(()=>{
        if (appSwitcherResult?.__typename === 'QueryError') onError?.(new Error(appSwitcherResult.message ?? 'appSwitcher_availableProductsBySite failed'));
    }, [
        appSwitcherResult,
        onError
    ]);
    const { productLinksByProductType: productLinksByProductType, productLinksRequestStatus: productLinksRequestStatus } = (0, $42omo.useMemo)(()=>{
        const productLinksRequestStatus = !appSwitcherResult ? (0, $culkJ.RequestStatus).INIT : appSwitcherResult.__typename === 'QueryError' ? (0, $culkJ.RequestStatus).ERROR : appSwitcherResult.__typename === 'AppSwitcherAvailableProductsBySite' ? (0, $culkJ.RequestStatus).COMPLETE : (0, $culkJ.RequestStatus).INIT;
        const productLinksByProductType = new Map();
        if (appSwitcherResult?.__typename === 'AppSwitcherAvailableProductsBySite') {
            const products = appSwitcherResult.products;
            if (products?.length) for (const product of products){
                if (product.__typename === 'AppSwitcherSingleUrlProduct') {
                    if (product.url) productLinksByProductType.set(product.productType, [
                        {
                            url: product.url
                        }
                    ]);
                } else if (product.__typename === 'AppSwitcherSiteScopedProduct') {
                    const links = (product.sites ?? []).filter((site)=>Boolean(site.url)).map((site)=>({
                            cloudId: site.siteId,
                            url: site.url
                        }));
                    if (links.length) productLinksByProductType.set(product.productType, links);
                }
            }
        }
        return {
            productLinksByProductType: productLinksByProductType,
            productLinksRequestStatus: productLinksRequestStatus
        };
    }, [
        appSwitcherResult
    ]);
    const productLinksByProductTypeRef = (0, $42omo.useRef)(productLinksByProductType);
    productLinksByProductTypeRef.current = productLinksByProductType;
    const productLinksRequestStatusRef = (0, $42omo.useRef)(productLinksRequestStatus);
    productLinksRequestStatusRef.current = productLinksRequestStatus;
    const lastCompleteProductLinksByTypeRef = (0, $42omo.useRef)(new Map());
    if (productLinksRequestStatus === (0, $culkJ.RequestStatus).COMPLETE) lastCompleteProductLinksByTypeRef.current = new Map(productLinksByProductType);
    const getRelayProductLinksForKey = (0, $42omo.useCallback)((apsKey)=>({
            links: ((0, $dh538.fg)('navx-gas-getlink-unstable-fix') ? lastCompleteProductLinksByTypeRef.current : productLinksByProductTypeRef.current).get(apsKey) ?? [],
            status: (0, $dh538.fg)('navx-gas-getlink-unstable-fix') ? (0, $culkJ.RequestStatus).COMPLETE : productLinksRequestStatusRef.current
        }), []);
    (0, $42omo.useEffect)(()=>{
        if (!onUpdateGetFilteredProductLinksRef.current) return;
        if (productLinksRequestStatus !== (0, $culkJ.RequestStatus).COMPLETE && (0, $dh538.fg)('navx-gas-getlink-unstable-fix')) return;
        onUpdateGetFilteredProductLinksRef.current(getRelayProductLinksForKey);
    }, [
        getRelayProductLinksForKey,
        productLinksRequestStatus,
        productLinksByProductType
    ]);
    const productUrlMap = (0, $42omo.useMemo)(()=>{
        const urlByProductType = new Map();
        for (const [productType, links] of productLinksByProductType.entries()){
            if (!links.length) continue;
            const match = cloudId ? links.find((l)=>l.cloudId === cloudId) : undefined;
            const chosen = match ?? links[0];
            if (chosen?.url) urlByProductType.set(productType, chosen.url);
        }
        return urlByProductType;
    }, [
        productLinksByProductType,
        cloudId
    ]);
    const appShortcuts = (0, $42omo.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hwDTW)))(shortcutsConfig)) return shortcutsConfig;
        const config = shortcutsConfig;
        if (!productUrlMap.size) return shortcutsConfig;
        const isArray = Array.isArray(config);
        if (isArray) return config.reduce((acc, item)=>{
            if (item.type !== 'link' || !item.apsKey) {
                acc.push(item);
                return acc;
            }
            const url = productUrlMap.get(item.apsKey);
            if (url) acc.push({
                ...item,
                url: url
            });
            return acc;
        }, []);
        const entries = Object.entries(config);
        return entries.reduce((acc, [key, value])=>{
            if (value.type !== 'link' || !value.apsKey) {
                acc[key] = value;
                return acc;
            }
            const url = productUrlMap.get(value.apsKey);
            if (url) acc[key] = {
                ...value,
                url: url
            };
            return acc;
        }, {});
    }, [
        productUrlMap,
        shortcutsConfig
    ]);
    return appShortcuts;
};
module.exports["useGlobalShortcutsDataRelay"] = $db75f94d1973e895$export$2dc34b66082250f3;

});

parcelRegister("culkJ", function(module, exports) {
var $062f3565ea2f6981$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
var $062f3565ea2f6981$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    // ATLAS_* - Need to be standalone apps to sit in this space
    Products["ATLAS_ALIGN"] = "ALIGN";
    Products["ATLAS_HOME"] = "ATLAS_HOME";
    Products["ATLAS_GOALS"] = "GOALS";
    Products["ATLAS_TEAMS"] = "TEAMS";
    Products["ATLAS_HUB"] = "ATLAS_HUB";
    Products["ANALYTICS"] = "ANALYTICS";
    Products["ASSETS"] = "ASSETS";
    Products["BITBUCKET"] = "BITBUCKET";
    Products["COMPASS"] = "COMPASS";
    Products["CUSTOMER_SERVICE_MANAGEMENT"] = "JIRA_CUSTOMER_SERVICE";
    Products["FOCUS"] = "mercury";
    Products["STUDIO"] = "STUDIO";
    Products["OPSGENIE"] = "OPSGENIE";
    Products["JIRA_SERVICE_MANAGEMENT"] = "JIRA_SERVICE_DESK";
    Products["JIRA_PRODUCT_DISCOVERY"] = "JIRA_PRODUCT_DISCOVERY";
    Products["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    Products["CONFLUENCE"] = "CONFLUENCE";
    Products["LOOM"] = "LOOM";
    Products["PROJECTS"] = "PROJECTS";
    Products["TALENT"] = "TALENT";
    Products["TRELLO"] = "TRELLO";
    Products["FEEDBACK"] = "FEEDBACK";
    return Products;
}({});
const $062f3565ea2f6981$export$85183a312807388d = 'navigation';
module.exports["RequestStatus"] = $062f3565ea2f6981$export$600e7c1f9e0414e1;
module.exports["Products"] = $062f3565ea2f6981$export$92e44ea1079b9ec6;
module.exports["ANALYTICS_CHANNEL"] = $062f3565ea2f6981$export$85183a312807388d;

});

parcelRegister("4dZdq", function(module, exports) {
$parcel$export(module.exports, "default", () => $90d298896f2aeaed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8307d24646dec2179f7b4020c61d570b>>
 * @relayHash 86994beb11f4ef7c8af21523816aa062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d25c1a9e348f5cef268af0c5a574df9a275e97bc5093fe2bce8d15900b232a1c
const $b5a6034e8a27c6c6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "productType"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalShortcutsRelayClientQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useGlobalShortcutsDataRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalShortcutsRelayClientQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "appSwitcher_availableProductsBySite",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "products",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ],
                                            "type": "AppSwitcherSingleUrlProduct"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "AppSwitcherProductSite",
                                                    "kind": "LinkedField",
                                                    "name": "sites",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "siteId"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "AppSwitcherSiteScopedProduct"
                                        }
                                    ]
                                }
                            ],
                            "type": "AppSwitcherAvailableProductsBySite"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d25c1a9e348f5cef268af0c5a574df9a275e97bc5093fe2bce8d15900b232a1c",
            "metadata": {},
            "name": "GlobalShortcutsRelayClientQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b5a6034e8a27c6c6$var$node.hash = "293957e10078d4cb40237c0fdc35aadd";
var $b5a6034e8a27c6c6$export$2e2bcd8739ae039 = $b5a6034e8a27c6c6$var$node;



var $42omo = parcelRequire("42omo");


var $hwDTW = parcelRequire("hwDTW");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $gWF6I = parcelRequire("gWF6I");


var $lchQJ = parcelRequire("lchQJ");

const $90d298896f2aeaed$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $42omo.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block prop propagation into the Suspense boundary while locked (during hydration)
    return nextProps.isLocked;
});
function $90d298896f2aeaed$var$HydrationSafeSuspense({ fallback: fallback = null, children: children }) {
    // Always start locked (true) regardless of SSR or CSR — this covers both SSR hydration
    // AND client-side transitions (e.g. edit mode) where process.env.REACT_SSR is false
    // but React still needs the boundary to stay stable until after the first mount.
    const [isLocked, setIsLocked] = (0, $42omo.useState)(true);
    (0, $42omo.useEffect)(()=>{
        setIsLocked(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($90d298896f2aeaed$var$HydrationSafeSuspenseContent, {
        isLocked: isLocked,
        fallback: fallback
    }, children);
}
const $90d298896f2aeaed$var$emptySubscribe = ()=>()=>{};
/**
 * Returns `false` during SSR and the client's hydrating render, then `true` once React has finished
 * hydrating this subtree
 */ function $90d298896f2aeaed$var$useIsHydrated() {
    return (0, $42omo.useSyncExternalStore)($90d298896f2aeaed$var$emptySubscribe, ()=>true, ()=>false);
}
function $90d298896f2aeaed$export$2e2bcd8739ae039(props) {
    const isHydrated = $90d298896f2aeaed$var$useIsHydrated();
    // Render Skip until after mount so the Suspense boundary only mounts post-hydration (avoids #421).
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.RelayEnvironmentProvider), null, !isHydrated && (0, $dh538.fg)('confluence_global_shortcuts_hydration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($90d298896f2aeaed$var$GlobalShortcutsRelayClientSkip, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($90d298896f2aeaed$var$HydrationSafeSuspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($90d298896f2aeaed$var$GlobalShortcutsRelayClientSkip, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($90d298896f2aeaed$var$GlobalShortcutsRelayClientImpl, props)));
}
function $90d298896f2aeaed$var$GlobalShortcutsRelayClientImpl(props) {
    const shouldFetch = Boolean(props.cloudId) && !props.isShortcutsStatic && !(0, (/*@__PURE__*/$parcel$interopDefault($hwDTW)))(props.shortcutsConfig);
    const [queryRef, loadQuery] = (0, $irOoi.useQueryLoader)((0, $b5a6034e8a27c6c6$export$2e2bcd8739ae039));
    (0, $42omo.useEffect)(()=>{
        if (!shouldFetch) return;
        (0, $42omo.startTransition)(()=>{
            loadQuery({
                cloudId: props.cloudId ?? ''
            });
        });
    }, [
        shouldFetch,
        props.cloudId,
        loadQuery
    ]);
    if (!shouldFetch || queryRef == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($90d298896f2aeaed$var$GlobalShortcutsRelayClientSkip, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($90d298896f2aeaed$var$GlobalShortcutsRelayClientPreloaded, {
        queryRef: queryRef,
        ...props
    });
}
function $90d298896f2aeaed$var$GlobalShortcutsRelayClientSkip({ children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    const shortcutItems = (0, $lchQJ.useGlobalShortcutsDataRelay)({
        queryRef: undefined,
        shortcutsConfig: shortcutsConfig,
        cloudId: cloudId,
        onError: onError,
        product: product,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children(shortcutItems));
}
function $90d298896f2aeaed$var$GlobalShortcutsRelayClientPreloaded({ queryRef: queryRef, children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    const queryData = (0, $irOoi.usePreloadedQuery)((0, $b5a6034e8a27c6c6$export$2e2bcd8739ae039), queryRef);
    const shortcutItems = (0, $lchQJ.useGlobalShortcutsDataRelay)({
        queryRef: queryData,
        shortcutsConfig: shortcutsConfig,
        cloudId: cloudId,
        onError: onError,
        product: product,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children(shortcutItems));
}

});

parcelRegister("cxAFf", function(module, exports) {
$parcel$export(module.exports, "useGlobalShortcutsDataBFF", () => (parcelRequire("bVKFx")).useGlobalShortcutsDataBFF);
/* eslint-disable import/order */ 
var $bVKFx = parcelRequire("bVKFx");


var $lchQJ = parcelRequire("lchQJ");

const $1004d7345af5d08f$export$bc8645ef40313f94 = (0, $bVKFx.useGlobalShortcutsDataBFF);

});

parcelRegister("fufCn", function(module, exports) {
/* top-level-spacer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6BXcn = parcelRequire("6BXcn");

const $1ca1d15a95304e4c$var$styles = {
    root: "_4t3iutpp"
}; /**
    * Use this component to create visual separation between the:
    *
    * - global app shortcut section
    * - 'more' button menu item
    * - starred spaces (in Confluence)
    *
    * Only use this component in the top level of the menu,
    * and exercise caution when using it in new situations.
    *
    * This component exists to fulfil product design requirements but has not yet
    * been consolidated into the wider navigation system.
    *
    * It may not exist in the future when global apps are no longer in the side navigation.
    */ 
function $1ca1d15a95304e4c$export$5776f68925982056() {
    const level = (0, $6BXcn.useLevel)();
    (0, $42omo.useEffect)(()=>{}, [
        level
    ]);
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $1ca1d15a95304e4c$var$styles.root
        ]),
        "data-vc": "FXMkvT-M"
    });
}
module.exports["TopLevelSpacer"] = $1ca1d15a95304e4c$export$5776f68925982056;

});

parcelRegister("fdzcy", function(module, exports) {
const $4cf608509dac3bd2$export$72b069d0875dccc = {
    MENU: 'L1MenuGroup',
    SHORTCUTS: 'L1ShortcutsGroup'
};
module.exports["L1_MENU_GROUPS"] = $4cf608509dac3bd2$export$72b069d0875dccc;

});

parcelRegister("6IuK2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");

// When a user drags & drops a navigation item, ADS recommends that we flash the item visually, and if the move was
// triggered by keyboard, also set focus to the moved item. This element registry allows GSN to keep track of the
// actual HTML elements of the L1 items, so that we can flash and focus them after the drag & drop action is performed.
// This pattern is recommended by AtlasKit in the side nav drag & drop documentation:
// https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#on-drop
const $070361eb324e4c27$var$MORE_MENU_ID = Symbol('moreMenuId');
function $070361eb324e4c27$export$b8d30beb0c187a7() {
    const registry = new Map();
    function registerL1Item({ id: id, element: element }) {
        registry.set(id, element);
        return function cleanup() {
            registry.delete(id);
        };
    }
    function getL1ItemElement(id) {
        return registry.get(id);
    }
    function registerMoreMenuItem(element) {
        return registerL1Item({
            id: $070361eb324e4c27$var$MORE_MENU_ID,
            element: element
        });
    }
    function getMoreMenuElement() {
        return getL1ItemElement($070361eb324e4c27$var$MORE_MENU_ID);
    }
    return {
        getL1ItemElement: getL1ItemElement,
        getMoreMenuElement: getMoreMenuElement,
        registerL1Item: registerL1Item,
        registerMoreMenuItem: registerMoreMenuItem
    };
}
const $070361eb324e4c27$var$ElementRegistryContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
function $070361eb324e4c27$export$ce0cc6a5e9b6a71a({ children: children, registry: registry }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($070361eb324e4c27$var$ElementRegistryContext.Provider, {
        value: registry
    }, children);
}
function $070361eb324e4c27$export$9a176103b34f9da9() {
    const elementRegistry = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($070361eb324e4c27$var$ElementRegistryContext);
    (0, $dRnqM.default)(elementRegistry, 'useElementRegistry must be used within an ElementRegistryProvider');
    return elementRegistry;
}
module.exports["createElementRegistry"] = $070361eb324e4c27$export$b8d30beb0c187a7;
module.exports["ElementRegistryProvider"] = $070361eb324e4c27$export$ce0cc6a5e9b6a71a;
module.exports["useElementRegistry"] = $070361eb324e4c27$export$9a176103b34f9da9;

});

parcelRegister("kkRaq", function(module, exports) {
const $0f77ee396fe887e6$var$l1ItemKey = Symbol('l1ItemKey');
const $0f77ee396fe887e6$var$nestedItemKey = Symbol('nestedItemKey');
const $0f77ee396fe887e6$var$moreMenuKey = Symbol('moreMenuKey');
const $0f77ee396fe887e6$export$a1dfda61267432e5 = (data)=>({
        ...data,
        type: 'menu-item',
        [$0f77ee396fe887e6$var$l1ItemKey]: true
    });
const $0f77ee396fe887e6$export$e9f7c92759d0f281 = (data)=>({
        ...data
    });
const $0f77ee396fe887e6$export$e52c346726a16591 = (data)=>{
    return data[$0f77ee396fe887e6$var$l1ItemKey] === true;
};
const $0f77ee396fe887e6$export$9d9fcc463b545806 = (data, groups)=>{
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
};
const $0f77ee396fe887e6$export$7960450fbf5a0a72 = Symbol('moreMenuId');
function $0f77ee396fe887e6$export$e74f096ffe08821d() {
    return {
        menuItemId: $0f77ee396fe887e6$export$7960450fbf5a0a72,
        [$0f77ee396fe887e6$var$moreMenuKey]: true
    };
}
function $0f77ee396fe887e6$export$e37de48254c6595e(data) {
    return data[$0f77ee396fe887e6$var$moreMenuKey] === true;
}
const $0f77ee396fe887e6$export$fe7d1a1bab9e2488 = (data)=>({
        ...data,
        type: 'menu-item',
        [$0f77ee396fe887e6$var$nestedItemKey]: true
    });
const $0f77ee396fe887e6$export$db162439b96bd9a8 = (data)=>{
    return {
        ...data,
        [$0f77ee396fe887e6$var$nestedItemKey]: true
    };
};
const $0f77ee396fe887e6$export$23cae75a8064fbc1 = (data)=>{
    return data[$0f77ee396fe887e6$var$nestedItemKey] === true;
};
const $0f77ee396fe887e6$export$a3f9aca82641b845 = (data, groups)=>{
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
};
const $0f77ee396fe887e6$export$98ff4de2f070152d = {
    MOVE_TO_TOP: 'MOVE_TO_TOP',
    MOVE_UP: 'MOVE_UP',
    MOVE_DOWN: 'MOVE_DOWN',
    MOVE_TO_BOTTOM: 'MOVE_TO_BOTTOM',
    BEFORE: 'reorder-before',
    AFTER: 'reorder-after'
};
module.exports["createL1ItemData"] = $0f77ee396fe887e6$export$a1dfda61267432e5;
module.exports["getL1ItemData"] = $0f77ee396fe887e6$export$e9f7c92759d0f281;
module.exports["isL1ItemData"] = $0f77ee396fe887e6$export$e52c346726a16591;
module.exports["isL1ItemDataInGroup"] = $0f77ee396fe887e6$export$9d9fcc463b545806;
module.exports["getMoreMenuData"] = $0f77ee396fe887e6$export$e74f096ffe08821d;
module.exports["isMoreMenuData"] = $0f77ee396fe887e6$export$e37de48254c6595e;

});

parcelRegister("NlNUL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6mkwk = parcelRequire("6mkwk");


var $bzNqF = parcelRequire("bzNqF");


var $l5LHO = parcelRequire("l5LHO");


var $jvL0g = parcelRequire("jvL0g");


var $5TK70 = parcelRequire("5TK70");

const $2f2d1e0caebca490$export$34e3b4eaa687835 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange }, forwardedRef)=>{
    const [isOpen, setIsOpen] = (0, $6mkwk.default)(isOpenControlled, ()=>isDefaultOpen);
    const previousIsOpen = (0, $bzNqF.default)(isOpen);
    const onCloseRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (previousIsOpen === undefined || previousIsOpen === isOpen) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        // When flyout menu is opened, fire analytics event
        if (isOpen && previousIsOpen === false) {
            const navigationAnalyticsEvent = createAnalyticsEvent({
                source: 'sideNav',
                actionSubject: 'flyoutMenu',
                action: 'opened'
            });
            navigationAnalyticsEvent.fire('navigation');
        }
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange,
        previousIsOpen,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5TK70.IsOpenContext).Provider, {
        value: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5TK70.SetIsOpenContext).Provider, {
        value: setIsOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5TK70.OnCloseContext).Provider, {
        value: onCloseRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jvL0g.MenuListItem), {
        ref: forwardedRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5LHO.Popup), {
        id: id,
        isOpen: isOpen,
        role: "dialog"
    }, children)))));
});
module.exports["FlyoutMenuItem"] = $2f2d1e0caebca490$export$34e3b4eaa687835;

});

parcelRegister("l5LHO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $dh538 = parcelRequire("dh538");


var $2xusd = parcelRequire("2xusd");


var $b5ZTM = parcelRequire("b5ZTM");


var $dfZW8 = parcelRequire("dfZW8");


var $krRQ7 = parcelRequire("krRQ7");


var $1kcB4 = parcelRequire("1kcB4");


var $4PRxb = parcelRequire("4PRxb");


var $5NfLM = parcelRequire("5NfLM");


var $aWbCY = parcelRequire("aWbCY");

const $9aa4c7c29923f177$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false, role: role })=>{
    const [triggerRef, setTriggerRef] = (0, $42omo.useState)(null);
    // When the top-layer flag is on, we maintain a stable RefObject for the
    // trigger element, provided through TriggerRefObjectContext. Unlike the
    // state-based triggerRef (which causes a re-render when the trigger mounts),
    // this ref has a stable identity so useAnchorPosition's useLayoutEffect dep
    // array never changes — the effect runs once on mount when the trigger element
    // is already populated. PopupTrigger sets this ref directly instead of calling
    // the state setter, avoiding an unnecessary re-render.
    const triggerRefObject = (0, $42omo.useRef)(null);
    const generatedId = (0, $c0qxy.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kcB4.RoleContext).Provider, {
        value: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dfZW8.EnsureIsInsidePopupContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5ZTM.IdContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5NfLM.TriggerRefContext).Provider, {
        value: triggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PRxb.SetTriggerRefContext).Provider, {
        value: setTriggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $krRQ7.IsOpenContext).Provider, {
        value: isOpen
    }, (0, $dh538.fg)('platform-dst-top-layer') ? // Skip Popper's <Manager> when Top Layer is being used.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aWbCY.TriggerRefObjectContext).Provider, {
        value: triggerRefObject
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2xusd.Manager), null, children)))))));
};
module.exports["Popup"] = $9aa4c7c29923f177$export$129a32eedafa97c5;

});

parcelRegister("g5d7N", function(module, exports) {
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $3654r = parcelRequire("3654r");


var $hND3b = parcelRequire("hND3b");


var $5TK70 = parcelRequire("5TK70");

const $910aa6df153038fc$var$FLYOUT_MENU_VERTICAL_OFFSET_PX = 26; /**
                                            * The maximum height of the flyout menu in pixels, following the Confluence standard maximum
                                            * height of 760px.
                                            */ 
const $910aa6df153038fc$var$FLYOUT_MENU_MAX_HEIGHT_PX = 760;
const $910aa6df153038fc$var$FLYOUT_MENU_PADDING = "var(--ds-space-100, 8px)"; /**
                                                         * The margin around the flyout menu popup when it has its modal appearance on mobile screen sizes.
                                                         */ 
const $910aa6df153038fc$var$FLYOUT_MENU_MODAL_MARGIN = 4;
const $910aa6df153038fc$var$maxHeightCssVar = '--max-height';
const $910aa6df153038fc$var$flyoutMenuItemContentStyles = {
    root: "_1q51u2gc _85i5u2gc _bozgu2gc _y4tiu2gc _14b51kdj"
};
const $910aa6df153038fc$var$flyoutMenuItemContentContainerStyles = {
    container: "_1e0c1txw _4t3i1osq _2lx21bp4 _c71lq9dn _1jop304o"
};
const $910aa6df153038fc$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose, autoFocus: autoFocus, maxHeight: maxHeight = $910aa6df153038fc$var$FLYOUT_MENU_MAX_HEIGHT_PX }, forwardedRef)=>{
    const setIsOpen = (0, $42omo.useContext)((0, $5TK70.SetIsOpenContext));
    const onCloseRef = (0, $42omo.useContext)((0, $5TK70.OnCloseContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)(); // The source of the close is not accessible to the consumer, it is determined within the
    // handleClose function, or passed in as a parameter in FlyoutMenuItemTrigger (outside-click),
    // or FlyoutHeader (close-button).
    const handleClose = (0, $42omo.useCallback)((event, source)=>{
        // Use the passed source if provided, otherwise determine from event
        let determinedSource = source || 'other';
        if (!source) {
            if (event instanceof KeyboardEvent) {
                const keyboardEvent = event;
                if (keyboardEvent.key === 'Escape' || keyboardEvent.key === 'Esc') determinedSource = 'escape-key';
            } else if (event instanceof MouseEvent) {
                if (event && 'type' in event && event.type === 'click') determinedSource = 'outside-click';
            }
        } // When flyout menu is closed, fire analytics event
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'sideNav',
            actionSubject: 'flyoutMenu',
            action: 'closed',
            attributes: {
                closeSource: determinedSource
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose,
        createAnalyticsEvent
    ]); // Register handleClose in the ref to allow the FlyoutMenuItemTrigger to access it
    (0, $42omo.useEffect)(()=>{
        onCloseRef.current = handleClose;
    }, [
        handleClose,
        onCloseRef
    ]);
    const titleId = (0, $42omo.useId)();
    const computedMaxHeight = (0, $42omo.useMemo)(()=>/**
   * The max height of the flyout menu needs to factor in the top nav and banner, as it will be layered
   * beneath them and would otherwise be clipped.
   *
   * We can remove these navigation variables once layering has been addressed holistically (e.g. using Top Layer).
   *
   * Not using the UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY variable from `@atlaskit/navigation-system`
   * to avoid a circular dependency, as that package imports this one for re-exporting components.
   */ `min(calc(100vh - ${$910aa6df153038fc$var$FLYOUT_MENU_VERTICAL_OFFSET_PX}px - var(--n_tNvM, 0px) - var(--n_bnrM, 0px)), ${maxHeight}px)`, [
        maxHeight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hND3b.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        // code that stops events. We _really_ want to close the flyout whenever
        // user user clicks outside the flyout content
        shouldUseCaptureOnOutsideClick: true,
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $910aa6df153038fc$var$flyoutMenuItemContentStyles.root,
        autoFocus: autoFocus,
        role: "dialog",
        titleId: titleId,
        shouldDisableGpuAcceleration: true,
        shouldRenderToParent: true
    }, ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($910aa6df153038fc$var$UpdatePopperOnContentResize, {
            ref: forwardedRef,
            update: update
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5TK70.TitleIdContextProvider), {
            value: titleId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                [$910aa6df153038fc$var$maxHeightCssVar]: computedMaxHeight
            },
            "data-testid": containerTestId ? `${containerTestId}--container` : undefined,
            className: (0, $gMc0m.default)([
                $910aa6df153038fc$var$flyoutMenuItemContentContainerStyles.container
            ])
        }, children))));
});
function $910aa6df153038fc$var$createResizeObserver(update) {
    return new ResizeObserver(update);
} /**
   * Will call the Popper.js `update()` method to recalculate positioning, when the flyout menu changes size.
   * This is the size of the scroll container, NOT the scroll content.
   *
   * We could potentially bake this into `@atlaskit/popup` or `@atlaskit/popper` but there are a few
   * reasons to keep it scoped to flyout menus for now:
   *
   * 1. It's easier to unwind
   * 2. We've only had bug reports for flyout menus
   * 3. Popup exposes the `update` function so consumers can already do this themselves if necessary
   * 4. Flyout menus are a lot more restricted to other popups, it might not make sense more generally
   */ 
const $910aa6df153038fc$var$UpdatePopperOnContentResize = /*#__PURE__*/ (0, $42omo.forwardRef)(({ update: update, children: children }, forwardedRef)=>{
    /**
   * Storing our `update` function in a ref so that we have a stable reference to it.
   * We need this because our `ResizeObserver` callback cannot be changed after creating it.
   */ const updateRef = (0, $42omo.useRef)(update);
    (0, $42omo.useEffect)(()=>{
        updateRef.current = update;
    }, [
        update
    ]); /**
                 * Stable function that calls the latest `update` function by calling it through the stable ref.
                 */ 
    const triggerUpdate = (0, $42omo.useCallback)(()=>{
        updateRef.current?.();
    }, []);
    const [resizeObserver] = (0, $42omo.useState)(()=>$910aa6df153038fc$var$createResizeObserver(triggerUpdate)); /**
                                                                                 * This is a callback ref that will update which `HTMLElement` we are observing,
                                                                                 * if or when the underlying `HTMLElement` changes or unmounts.
                                                                                 */ 
    const observeCallbackRef = (0, $42omo.useCallback)((element)=>{
        /**
     * Unobserves all observed elements.
     * Allows us to cleanup without needing to store a reference to the previous element.
     */ resizeObserver.disconnect();
        if (!element) return;
        resizeObserver.observe(element);
    }, [
        resizeObserver
    ]); /**
                         * We need to memoize the ref otherwise `triggerUpdate` is repeatedly called.
                         *
                         * This stems from ResizeObserver firing once after calling `.observe()` even if there
                         * was no resize.
                         *
                         * Without memoizing the ref, the update causes a rerender, which causes the ref to
                         * get recreated, which triggers an update and so on in a loop.
                         */ 
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            forwardedRef,
            observeCallbackRef
        ]);
    }, [
        forwardedRef,
        observeCallbackRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        "data-vc": "4tM6Wab-"
    }, children);
});
module.exports["FlyoutMenuItemContent"] = $910aa6df153038fc$export$2ca9a13c57a8839a;

});

parcelRegister("hND3b", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cebtu = parcelRequire("cebtu");


var $if5rb = parcelRequire("if5rb");


var $dh538 = parcelRequire("dh538");


var $caX7N = parcelRequire("caX7N");


var $2cdko = parcelRequire("2cdko");


var $fiAWX = parcelRequire("fiAWX");


var $b5ZTM = parcelRequire("b5ZTM");


var $krRQ7 = parcelRequire("krRQ7");

/* popup-content-top-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $ee7An = parcelRequire("ee7An");


var $hFC20 = parcelRequire("hFC20");


var $bgEkj = parcelRequire("bgEkj");


var $gpUNi = parcelRequire("gpUNi");

var $4Mlap = parcelRequire("4Mlap");


var $4S3pg = parcelRequire("4S3pg");


var $itGS3 = parcelRequire("itGS3");


var $hewu1 = parcelRequire("hewu1");


var $5YRQl = parcelRequire("5YRQl");


var $aWbCY = parcelRequire("aWbCY");

const $c298df641e5a4861$var$overflowAutoStyles = null;
const $c298df641e5a4861$var$animation = (0, $hFC20.slideAndFade)(); // Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
const $c298df641e5a4861$var$EMPTY_STYLE = {}; /**
                                        * Top-layer implementation of the compositional PopupContent.
                                        *
                                        * Reads isOpen, id, triggerRef from the legacy compositional Popup context,
                                        * then renders via @atlaskit/top-layer's Popup compound.
                                        *
                                        * Gated behind the `platform-dst-top-layer` feature flag.
                                        */ 
function $c298df641e5a4861$export$a126ab411f00d484({ xcss: xcss, children: children, offset: offsetProp, onClose: onClose, testId: testId, placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, role: role, label: label, titleId: titleId, isOpen: isOpen, id: providedId, // ── No-op props ──
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, // top-layer: shouldFlip handled by CSS position-try fallbacks.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldFlip: _shouldFlip, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance, // top-layer: GPU acceleration is not applicable.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableGpuAcceleration: _shouldDisableGpuAcceleration }) {
    const [, setInitialFocusRef] = (0, $42omo.useState)(null); // ── Placement conversion ──
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape.
    const topLayerPlacement = (0, $42omo.useMemo)(()=>(0, $bgEkj.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]); // ── onClose bridge ──
    const handleOnClose = (0, $42omo.useCallback)(({ reason: reason })=>{
        if (!onClose) return;
        onClose((0, $gpUNi.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]); // ── Content render-prop bridge ──
    const contentProps = (0, $42omo.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $ee7An.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose
    ]); // ── Role mapping ──
    const roleProps = (0, $5YRQl.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    const popoverRef = (0, $42omo.useRef)(null);
    const anchorRef = (0, $42omo.useContext)((0, $aWbCY.TriggerRefObjectContext)); // `isOpen` is included so the anchor positioning effect re-runs when
    // the Popover host element is unmounted/remounted across open cycles.
    (0, $itGS3.useAnchorPosition)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    });
    (0, $hewu1.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'match-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: anchorRef,
        isOpen: isOpen
    }); // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer;
    return /*#__PURE__*/ $42omo.createElement((0, $4Mlap.Popover), {
        ref: popoverRef,
        ...roleProps,
        isOpen: isOpen,
        animate: $c298df641e5a4861$var$animation,
        placement: topLayerPlacement,
        onClose: handleOnClose,
        testId: testId && `${testId}--content`
    }, Container ? /*#__PURE__*/ $42omo.createElement(Container, {
        style: $c298df641e5a4861$var$EMPTY_STYLE,
        id: providedId,
        "data-placement": placement,
        "data-testid": testId,
        tabIndex: autoFocus ? -1 : undefined,
        xcss: xcss
    }, children(contentProps)) : /*#__PURE__*/ $42omo.createElement((0, $4S3pg.PopoverSurface), null, /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            shouldFitViewport && "_1reo1wug _18m91wug",
            (0, $gMc0m.default)([
                xcss
            ])
        ]),
        "data-vc": "iS1q6V9J"
    }, children(contentProps))));
}



var $5NfLM = parcelRequire("5NfLM");


var $3T4mU = parcelRequire("3T4mU");

const $ad7655198387e8c0$var$defaultLayer = 400;
const $ad7655198387e8c0$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
const $ad7655198387e8c0$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $ad7655198387e8c0$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false, role: role, label: label, titleId: titleId })=>{
    (0, $3T4mU.useEnsureIsInsidePopup)();
    const isOpen = (0, $42omo.useContext)((0, $krRQ7.IsOpenContext));
    const id = (0, $42omo.useContext)((0, $b5ZTM.IdContext));
    const triggerRef = (0, $42omo.useContext)((0, $5NfLM.TriggerRefContext));
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $fiAWX.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $42omo.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    // On the top-layer path, the Popover primitive registers with the observer
    // directly, so we skip registration here to avoid double-counting.
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, $dh538.fg)('platform-dst-top-layer')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // Top-layer rendering path: native Popover API via @atlaskit/top-layer.
    // Mirrors the FF branch in the legacy `Popup` component (popup.tsx).
    if ((0, $dh538.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c298df641e5a4861$export$a126ab411f00d484), {
        xcss: xcss,
        appearance: inAppearance,
        offset: offset,
        onClose: onClose,
        testId: testId,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        popupComponent: popupComponent,
        autoFocus: autoFocus,
        shouldFitContainer: shouldFitContainer,
        shouldFitViewport: shouldFitViewport,
        role: role,
        label: label,
        titleId: titleId,
        zIndex: zIndex,
        shouldRenderToParent: inShouldRenderToParent,
        strategy: strategy,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldFlip: shouldFlip,
        shouldDisableGpuAcceleration: shouldDisableGpuAcceleration,
        isOpen: isOpen,
        id: id
    }, children);
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cebtu.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2cdko.default), {
        xcss: xcss,
        appearance: appearance,
        content: children,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: popupComponent,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldFitContainer: shouldFitContainer,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: shouldDisableFocusLock,
        triggerRef: triggerRef,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        modifiers: shouldDisableGpuAcceleration ? $ad7655198387e8c0$var$shouldDisableGpuAccelerationModifiers : undefined,
        role: role,
        titleId: titleId
    }));
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: zIndex
    }, popperWrapper);
};
module.exports["PopupContent"] = $ad7655198387e8c0$export$2a2c7ba12d3231e3;

});

parcelRegister("j3gDz", function(module, exports) {
/* flyout-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3654r = parcelRequire("3654r");


var $6R5uz = parcelRequire("6R5uz");


var $lNGn6 = parcelRequire("lNGn6");


var $8njHX = parcelRequire("8njHX");


var $5TK70 = parcelRequire("5TK70");

const $c5670daf8d79877c$var$elemAfterStyles = {
    root: "_18zr12x7 _1tz3r0mg"
};
const $c5670daf8d79877c$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const isOpen = (0, $42omo.useContext)((0, $5TK70.IsOpenContext));
    const onCloseRef = (0, $42omo.useContext)((0, $5TK70.OnCloseContext));
    const handleClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        if (isOpen && onCloseRef.current) onCloseRef.current(event, 'outside-click');
        onClick?.(event, analyticsEvent);
    }, [
        isOpen,
        onCloseRef,
        onClick
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $lNGn6.PopupTrigger), null, ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ $42omo.createElement((0, $8njHX.MenuItemBase), {
            testId: testId,
            ref: (0, $3654r.default)([
                ref,
                forwardedRef
            ]),
            visualContentRef: visualContentRef,
            elemBefore: elemBefore,
            elemAfter: /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    $c5670daf8d79877c$var$elemAfterStyles.root
                ]),
                "data-vc": "fb38hhUu"
            }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                label: "",
                color: "currentColor",
                size: "small"
            })),
            onClick: handleClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isSelected: isSelected,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children));
});
module.exports["FlyoutMenuItemTrigger"] = $c5670daf8d79877c$export$9f59f399fe37b6ca;

});

parcelRegister("lNGn6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $cs0ez = parcelRequire("cs0ez");


var $advfQ = parcelRequire("advfQ");


var $b5ZTM = parcelRequire("b5ZTM");


var $krRQ7 = parcelRequire("krRQ7");


var $1kcB4 = parcelRequire("1kcB4");


var $4PRxb = parcelRequire("4PRxb");


var $aWbCY = parcelRequire("aWbCY");


var $3T4mU = parcelRequire("3T4mU");

const $3077108f79c5b694$export$95d4acdbab2fc6ef = ({ children: children })=>{
    (0, $3T4mU.useEnsureIsInsidePopup)();
    const id = (0, $42omo.useContext)((0, $b5ZTM.IdContext));
    const setTriggerRef = (0, $42omo.useContext)((0, $4PRxb.SetTriggerRefContext));
    const triggerRefObject = (0, $42omo.useContext)((0, $aWbCY.TriggerRefObjectContext));
    const isOpen = (0, $42omo.useContext)((0, $krRQ7.IsOpenContext));
    const getMergedTriggerRef = (0, $advfQ.useGetMemoizedMergedTriggerRefNew)();
    const role = (0, $42omo.useContext)((0, $1kcB4.RoleContext));
    // Stable ref callback — avoids creating a new function instance on every render,
    // which would cause React to detach and reattach the ref unnecessarily.
    // triggerRefObject is a MutableRefObject (from useRef) so its identity never changes,
    // meaning this callback is effectively created once per mount.
    const triggerRef = (0, $42omo.useCallback)((node)=>{
        triggerRefObject.current = node;
    }, [
        triggerRefObject
    ]);
    const ariaHasPopup = role === 'dialog' ? 'dialog' : true;
    // When the top-layer flag is on, bypass Popper's <Reference> entirely.
    // We only need to set triggerRefObject.current — no Popper ref merging needed.
    if ((0, $dh538.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children({
        ref: triggerRef,
        'aria-controls': id,
        'aria-expanded': isOpen,
        'aria-haspopup': ariaHasPopup
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cs0ez.Reference), null, ({ ref: ref })=>children({
            ref: getMergedTriggerRef(ref, setTriggerRef),
            'aria-controls': id,
            'aria-expanded': isOpen,
            'aria-haspopup': ariaHasPopup
        }));
};
module.exports["PopupTrigger"] = $3077108f79c5b694$export$95d4acdbab2fc6ef;

});

parcelRegister("3H0hg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kkRaq = parcelRequire("kkRaq");





var $1CBf6 = parcelRequire("1CBf6");


var $6IuK2 = parcelRequire("6IuK2");

function $eca3be981a059a11$export$9d7e63760538f47f(item) {
    if (!item || item.type === 'custom' && item.dragPreviewContent) // If the custom item has a drag preview content, we should assume it contains the icon already
    return undefined;
    return item.elemBefore;
}
function $eca3be981a059a11$export$d5d05b25e1604a8f(item, name) {
    if (!item) {
        if (name) return name;
        return undefined;
    }
    if (item.type === 'custom' && item.dragPreviewContent) // Custom items may return their drag preview content as a React node
    return item.dragPreviewContent;
    // If not custom or drag preview content not present, use the label
    return item.labelElem ?? item.label;
}


function $4652fe225d9e3686$export$4696d1da23170d9a(props) {
    const { data: data, item: item, id: id, isExpandable: isExpandable, isItemDraggable: isItemDraggable, isItemDroppable: isItemDroppable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isDragAndDropEnabled: isDragAndDropEnabled, group: group, isItemDataInGroup: isItemDataInGroup, isItemData: isItemData, getItemData: getItemData } = props;
    const itemIsDraggable = isItemDraggable?.(data) ?? !!isDragAndDropEnabled;
    const itemIsDroppable = isItemDroppable?.(data) ?? !!isDragAndDropEnabled;
    const getInitialData = (0, $42omo.useCallback)(()=>getItemData({
            ...data,
            menuItemId: id,
            group: group
        }), [
        data,
        getItemData,
        group,
        id
    ]);
    const getDragPreviewPieces = (0, $42omo.useCallback)(()=>({
            elemBefore: (0, $eca3be981a059a11$export$9d7e63760538f47f)(item),
            content: (0, $eca3be981a059a11$export$d5d05b25e1604a8f)(item, data?.label)
        }), [
        data?.label,
        item
    ]);
    const canDrag = (0, $42omo.useCallback)(()=>isItemDraggable ? isItemDraggable(data) : !!isDragAndDropEnabled, [
        data,
        isDragAndDropEnabled,
        isItemDraggable
    ]);
    const getData = (0, $42omo.useCallback)((args)=>{
        const { source: source } = args;
        return getItemData({
            ...data,
            menuItemId: id,
            group: source?.data?.group
        });
    }, [
        data,
        getItemData,
        id
    ]);
    const getOperations = (0, $42omo.useCallback)(()=>({
            'reorder-before': itemIsDraggable ? 'available' : undefined,
            'reorder-after': 'available'
        }), [
        itemIsDraggable
    ]);
    const canDrop = (0, $42omo.useCallback)((args)=>{
        const { source: source } = args;
        return isItemData(source.data) && source.data.menuItemId !== id && isItemDataInGroup(source.data, group);
    }, [
        group,
        id,
        isItemData,
        isItemDataInGroup
    ]);
    const draggable = (0, $42omo.useMemo)(()=>{
        if (isDragAndDropEnabled && itemIsDraggable) return {
            canDrag: canDrag,
            getInitialData: getInitialData,
            getDragPreviewPieces: getDragPreviewPieces
        };
    }, [
        canDrag,
        getInitialData,
        getDragPreviewPieces,
        isDragAndDropEnabled,
        itemIsDraggable
    ]);
    const dropTarget = (0, $42omo.useMemo)(()=>{
        if (isDragAndDropEnabled && itemIsDroppable) return {
            canDrop: canDrop,
            getData: getData,
            getOperations: getOperations
        };
    }, [
        canDrop,
        getData,
        getOperations,
        isDragAndDropEnabled,
        itemIsDroppable
    ]);
    const memoizedHookProps = (0, $42omo.useMemo)(()=>({
            draggable: draggable,
            dropTarget: dropTarget
        }), [
        draggable,
        dropTarget
    ]);
    const { draggableAnchorRef: draggableAnchorRef, draggableButtonRef: draggableButtonRef, state: dragState, dragPreview: dragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $1CBf6.useMenuItemDragAndDrop)(memoizedHookProps);
    const registry = (0, $6IuK2.useElementRegistry)();
    const registrationRef = (0, $42omo.useRef)(null);
    const draggableRef = (0, $42omo.useCallback)((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            draggableAnchorRef.current = null;
            draggableButtonRef.current = null;
            return;
        }
        if (element instanceof HTMLAnchorElement) draggableAnchorRef.current = element;
        else draggableButtonRef.current = element;
        if (registrationRef.current) registrationRef.current();
        registrationRef.current = registry.registerL1Item({
            id: id,
            element: element
        });
    }, [
        id,
        registry,
        draggableAnchorRef,
        draggableButtonRef,
        registrationRef
    ]);
    const isDragging = !!itemIsDraggable && dragState.type === 'dragging';
    const expandableClosedForDrag = (0, $42omo.useRef)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isExpandable || !itemIsDraggable) return;
        if (isDragging && isExpandOrFlyoutOpen) {
            onExpandFlyoutToggle(false);
            expandableClosedForDrag.current = true;
        } else if (!isDragging && expandableClosedForDrag.current) {
            onExpandFlyoutToggle(true);
            expandableClosedForDrag.current = false;
        }
    }, [
        isDragging,
        isExpandable,
        isExpandOrFlyoutOpen,
        itemIsDraggable,
        expandableClosedForDrag,
        onExpandFlyoutToggle
    ]);
    return (0, $42omo.useMemo)(()=>({
            draggableRef: itemIsDraggable ? draggableRef : undefined,
            isItemDraggable: itemIsDraggable,
            isItemDroppable: itemIsDroppable,
            isDragging: isDragging,
            dropTargetRef: itemIsDroppable ? dropTargetRef : undefined,
            dropIndicator: itemIsDroppable ? dropIndicator : undefined,
            maybeDragPreview: itemIsDraggable ? dragPreview : null
        }), [
        draggableRef,
        dragPreview,
        dropIndicator,
        dropTargetRef,
        isDragging,
        itemIsDraggable,
        itemIsDroppable
    ]);
}


function $f27439ed9e8d0aff$export$f8cda0f87a8e0691({ item: item, id: id, isExpandable: isExpandable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, peek: peek, l1DragAndDropEnabled: l1DragAndDropEnabled, group: group }) {
    const data = (0, $42omo.useMemo)(()=>(0, $kkRaq.createL1ItemData)({
            menuItemId: id,
            group: group,
            isHidden: false,
            isHideable: item.isHideable !== false,
            label: item.label,
            isReorderable: item.isReorderable !== false
        }), [
        group,
        id,
        item.isHideable,
        item.isReorderable,
        item.label
    ]);
    const isItemDraggable = (0, $42omo.useCallback)(()=>{
        return !!l1DragAndDropEnabled && !peek && (item.isHideable !== false || item.isReorderable !== false) && (item.type !== 'custom' || !!item.isDraggable);
    }, [
        item.isDraggable,
        item.isHideable,
        item.isReorderable,
        item.type,
        l1DragAndDropEnabled,
        peek
    ]);
    const isItemDroppable = (0, $42omo.useCallback)(()=>!!l1DragAndDropEnabled && !peek && (item.type !== 'custom' || !!item.isDraggable), [
        item.isDraggable,
        item.type,
        l1DragAndDropEnabled,
        peek
    ]);
    return (0, $4652fe225d9e3686$export$4696d1da23170d9a)({
        data: data,
        getItemData: (0, $kkRaq.getL1ItemData),
        group: group,
        id: id,
        item: item,
        isDragAndDropEnabled: l1DragAndDropEnabled,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        isItemData: (0, $kkRaq.isL1ItemData),
        isItemDataInGroup: (0, $kkRaq.isL1ItemDataInGroup),
        isItemDraggable: isItemDraggable,
        isItemDroppable: isItemDroppable,
        onExpandFlyoutToggle: onExpandFlyoutToggle
    });
}
module.exports["useL1ItemDragAndDrop"] = $f27439ed9e8d0aff$export$f8cda0f87a8e0691;

});

parcelRegister("1CBf6", function(module, exports) {
/* use-menu-item-drag-and-drop.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $4T4vf = parcelRequire("4T4vf");


var $882hS = parcelRequire("882hS");


var $afUmf = parcelRequire("afUmf");

/* drag-preview.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $9r5xQ = parcelRequire("9r5xQ");


var $8njHX = parcelRequire("8njHX");


var $6hmpf = parcelRequire("6hmpf");

function $72cfea0e315c18e6$var$isSafari() {
    if (typeof window === 'undefined') return false;
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
}
const $72cfea0e315c18e6$var$dragPreviewStyles = {
    root: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _bfhkvuon _y4ti1b66 _p12fgx0z",
    rootT26Shape: "_2rko1qi0",
    safariFix: "_1ul9uuw1"
}; /**
    * A drag preview for sidebar menu items.
    *
    * The limited API corresponds with the limited amount of information we
    * want to show in drag previews. Only essential information is shown.
    *
    * If no `elemBefore` is provided, then the `elemBefore` will automatically collapse.
    * There is no need to pass in `COLLAPSE_ELEM_BEFORE`. We do this as there is no
    * need to maintain vertical side navigation vertical alignment in the drag preview.
    *
    * Please ensure the drag preview is pushed away from the users pointer
    * (with `pointerOutsideOfPreview()` from Pragmatic drag and drop) by our
    * standard amount (`{x: token('space.200'), y: token('space.100')`)
    */ 
function $72cfea0e315c18e6$export$905ab40ac2179daa({ elemBefore: elemBefore, children: children }) {
    return(// Resetting the expandable menu items to 0.
    // This is to prevent our hidden element from pushing
    // the drag preview further away from the users pointer
    /*#__PURE__*/ $42omo.createElement((0, $9r5xQ.ExpandableMenuItemLevelContext).Provider, {
        value: 0
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $72cfea0e315c18e6$var$dragPreviewStyles.root,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $72cfea0e315c18e6$var$dragPreviewStyles.rootT26Shape,
            $72cfea0e315c18e6$var$isSafari() && $72cfea0e315c18e6$var$dragPreviewStyles.safariFix
        ]),
        "data-vc": "w-DbQw9P"
    }, /*#__PURE__*/ $42omo.createElement((0, $8njHX.MenuItemBase), {
        elemBefore: elemBefore ?? (0, $6hmpf.COLLAPSE_ELEM_BEFORE)
    }, children))));
}



var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aTio4 = parcelRequire("aTio4");


var $2n8po = parcelRequire("2n8po");

const $b531d8d12c7f91a5$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom'
    },
    horizontal: {
        start: 'left',
        end: 'right'
    }
};
function $b531d8d12c7f91a5$export$62ed72bc21f6b8a6({ instruction: instruction, lineGap: lineGap, lineType: lineType }) {
    const appearance = instruction.blocked ? 'warning' : 'default';
    const axis = $b531d8d12c7f91a5$var$axisLookup[instruction.axis];
    if (instruction.operation === 'combine') return /*#__PURE__*/ (0, $l998X.jsx)((0, $aTio4.DropIndicator), {
        appearance: appearance
    });
    if (instruction.operation === 'reorder-before') return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
        edge: axis.start,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    if (instruction.operation === 'reorder-after') return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
        edge: axis.end,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    return null;
}



var $cViGk = parcelRequire("cViGk");

const $a6db19c407748f40$var$idle = {
    type: 'idle'
};
function $a6db19c407748f40$export$fe281fdb09fbf0c8({ draggable: draggableArgs, dropTarget: dropTargetArgs }) {
    const draggableAnchorRef = (0, $42omo.useRef)(null);
    const draggableButtonRef = (0, $42omo.useRef)(null);
    const dropTargetRef = (0, $42omo.useRef)(null);
    const [internalState, setInternalState] = (0, $42omo.useState)($a6db19c407748f40$var$idle);
    const getDraggableElement = (0, $42omo.useCallback)(()=>{
        return draggableAnchorRef.current ?? draggableButtonRef.current ?? null;
    }, []); // Set up draggable
    (0, $42omo.useEffect)(()=>{
        // Don't set up a draggable if there are no draggable args
        if (!draggableArgs) return;
        const element = getDraggableElement(); // Some elements may initially want to use DnD, then decide not to render.
        // In that case, we don't want to throw an error.
        if (!element) return;
        return (0, $4T4vf.draggable)({
            element: element,
            getInitialData: draggableArgs.getInitialData,
            canDrag: draggableArgs.canDrag,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage, source: source, location: location }) {
                (0, $afUmf.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $882hS.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render ({ container: container }) {
                        const args = {
                            dragHandle: source.dragHandle,
                            element: source.element,
                            input: location.current.input
                        };
                        setInternalState({
                            type: 'preview',
                            container: container,
                            ui: draggableArgs.getDragPreviewPieces(args)
                        });
                    }
                });
            },
            onDragStart () {
                setInternalState({
                    type: 'dragging'
                });
            },
            onDrop () {
                setInternalState($a6db19c407748f40$var$idle);
            }
        });
    }, [
        draggableArgs,
        getDraggableElement
    ]);
    // Set up drop target
    (0, $42omo.useEffect)(()=>{
        if (!dropTargetArgs) return;
         // Don't need to provide a draggable element to have a drop target.
        // Using this element in our `canDrop` check
        const draggableElement = getDraggableElement();
        const dropTarget = dropTargetRef.current; // Some elements may initially want to use DnD, then decide not to render.
        // In that case, we don't want to throw an error
        if (!dropTarget) return;
        return (0, $4T4vf.dropTargetForElements)({
            element: dropTarget,
            // cannot drop on self
            canDrop: (args)=>{
                // cannot drop on self
                if (args.source.element === draggableElement) return false;
                if (dropTargetArgs.canDrop) return dropTargetArgs.canDrop(args);
                return true;
            },
            // menu items are always sticky, and the GroupDropIndicator should clear stickiness
            getIsSticky: ()=>true,
            getData (args) {
                const data = dropTargetArgs.getData?.(args) ?? {};
                const operations = dropTargetArgs.getOperations(args);
                return (0, $cViGk.attachInstruction)(data, {
                    input: args.input,
                    element: args.element,
                    operations: operations
                });
            },
            onDragStart ({ self: self }) {
                const instruction = (0, $cViGk.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            },
            onDrag ({ self: self }) {
                const instruction = (0, $cViGk.extractInstruction)(self.data);
                setInternalState((current)=>{
                    if (current.type === 'is-over' && instruction?.operation === current.instruction?.operation && instruction?.blocked === current.instruction?.blocked) return current;
                    return {
                        type: 'is-over',
                        instruction: instruction
                    };
                });
            },
            onDragLeave () {
                setInternalState($a6db19c407748f40$var$idle);
            },
            onDrop () {
                setInternalState($a6db19c407748f40$var$idle);
            },
            onDragEnter ({ self: self }) {
                const instruction = (0, $cViGk.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            }
        });
    }, [
        dropTargetArgs,
        getDraggableElement
    ]);
    const dragPreview = (()=>{
        if (internalState.type !== 'preview') return null;
        return /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ $42omo.createElement((0, $72cfea0e315c18e6$export$905ab40ac2179daa), {
            elemBefore: internalState.ui.elemBefore
        }, internalState.ui.content), internalState.container);
    })();
    const dropIndicator = internalState.type === 'is-over' && internalState.instruction && /*#__PURE__*/ $42omo.createElement((0, $b531d8d12c7f91a5$export$62ed72bc21f6b8a6), {
        instruction: internalState.instruction
    });
    const state = (0, $42omo.useMemo)(()=>{
        if (internalState.type === 'preview') return {
            type: 'preview'
        };
         // returning a new object to avoid modification of our `internalState` object
        return {
            ...internalState
        };
    }, [
        internalState
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: dragPreview,
        dropIndicator: dropIndicator
    };
}
module.exports["useMenuItemDragAndDrop"] = $a6db19c407748f40$export$fe281fdb09fbf0c8;

});

parcelRegister("cViGk", function(module, exports) {

var $fYKLM = parcelRequire("fYKLM");

// using a symbol so we can guarantee a key with a unique value
const $e47dc82918f0a9a8$var$uniqueKey = Symbol('list-item-instruction');
const $e47dc82918f0a9a8$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom',
        size: 'height',
        point: 'y'
    },
    horizontal: {
        start: 'left',
        end: 'right',
        size: 'width',
        point: 'x'
    }
};
function $e47dc82918f0a9a8$var$reorderAndCombine({ client: client, borderBox: borderBox, axis: axis }) {
    const quarterOfSize = borderBox[axis.size] / 4;
    // In the top 1/4: reorder-before
    // On the line: reorder-before to give a slight preference to reordering
    if (client[axis.point] <= borderBox[axis.start] + quarterOfSize) return 'reorder-before';
    // In the bottom 1/4: reorder-after
    // On the line: reorder-after to give a slight preference to reordering
    if (client[axis.point] >= borderBox[axis.end] - quarterOfSize) return 'reorder-after';
    return 'combine';
}
function $e47dc82918f0a9a8$var$reorder({ client: client, borderBox: borderBox, axis: axis }) {
    const halfSize = borderBox[axis.size] / 2;
    // In the top 1/2: reorder-before
    // On the line: reorder-after to give a slight preference to moving forward
    if (client[axis.point] < borderBox[axis.start] + halfSize) return 'reorder-before';
    return 'reorder-after';
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $e47dc82918f0a9a8$var$memoizeInstruction = (0, $fYKLM.stable)();
function $e47dc82918f0a9a8$var$isPossible(...values) {
    return values.every((value)=>value === 'available' || value === 'blocked');
}
function $e47dc82918f0a9a8$var$isNotAvailable(...values) {
    return values.every((value)=>value === 'not-available');
}
function $e47dc82918f0a9a8$export$267ad49d812c2c7f(userData, { operations: operations, element: element, input: input, axis: axisValue = 'vertical' }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    const axis = $e47dc82918f0a9a8$var$axisLookup[axisValue];
    const combine = operations.combine ?? 'not-available';
    const reorderAbove = operations['reorder-before'] ?? 'not-available';
    const reorderBelow = operations['reorder-after'] ?? 'not-available';
    const operation = (()=>{
        // Combining not possible
        if (!$e47dc82918f0a9a8$var$isPossible(combine)) {
            // can reorder above and below
            if ($e47dc82918f0a9a8$var$isPossible(reorderAbove, reorderBelow)) return $e47dc82918f0a9a8$var$reorder({
                client: client,
                borderBox: borderBox,
                axis: axis
            });
            // can only reorder above
            if ($e47dc82918f0a9a8$var$isPossible(reorderAbove)) return 'reorder-before';
            // can only reorder below
            if ($e47dc82918f0a9a8$var$isPossible(reorderBelow)) return 'reorder-after';
            // no `true` values - no Outcome available.
            return null;
        }
        // combining is available
        const result = $e47dc82918f0a9a8$var$reorderAndCombine({
            client: client,
            borderBox: borderBox,
            axis: axis
        });
        if (result === 'reorder-after') return $e47dc82918f0a9a8$var$isNotAvailable(reorderBelow) ? 'combine' : result;
        if (result === 'reorder-before') return $e47dc82918f0a9a8$var$isNotAvailable(reorderAbove) ? 'combine' : result;
        return result;
    })();
    // We cannot attach an instruction - all values passed where `false` or no values passed
    if (!operation) return userData;
    const instruction = {
        operation: operation,
        blocked: operations[operation] === 'blocked',
        axis: axisValue
    };
    const memoized = $e47dc82918f0a9a8$var$memoizeInstruction(instruction);
    return {
        ...userData,
        [$e47dc82918f0a9a8$var$uniqueKey]: memoized
    };
}
function $e47dc82918f0a9a8$export$c8ffecbe249dc8f8(userData) {
    return userData[$e47dc82918f0a9a8$var$uniqueKey] ?? null;
}
module.exports["attachInstruction"] = $e47dc82918f0a9a8$export$267ad49d812c2c7f;
module.exports["extractInstruction"] = $e47dc82918f0a9a8$export$c8ffecbe249dc8f8;

});

parcelRegister("gasvu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");


var $dh538 = parcelRequire("dh538");


var $bedQP = parcelRequire("bedQP");


var $eyWa4 = parcelRequire("eyWa4");


var $hnvzE = parcelRequire("hnvzE");


var $iKHTh = parcelRequire("iKHTh");


var $4jETc = parcelRequire("4jETc");

var $caUKj = parcelRequire("caUKj");


var $dBtY8 = parcelRequire("dBtY8");

var $5xxOu = parcelRequire("5xxOu");

var $5IDSL = parcelRequire("5IDSL");


var $4dZdq = parcelRequire("4dZdq");


var $gcpE0 = parcelRequire("gcpE0");


var $7FdE1 = parcelRequire("7FdE1");

// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)































const $b8f2a3af0ad05925$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("efIgK")),
    da: ()=>(parcelRequire("hiUSM")),
    de: ()=>(parcelRequire("byGvB")),
    en: ()=>Promise.resolve((parcelRequire("7FdE1"))),
    'en-GB': ()=>(parcelRequire("eWFBW")),
    'en-ZZ': ()=>(parcelRequire("7OubI")),
    es: ()=>(parcelRequire("i0vcp")),
    fi: ()=>(parcelRequire("i2aNt")),
    fr: ()=>(parcelRequire("jKwpu")),
    hr: ()=>(parcelRequire("ifns8")),
    hu: ()=>(parcelRequire("k8eXM")),
    it: ()=>(parcelRequire("lPxfk")),
    ja: ()=>(parcelRequire("bk5cw")),
    ko: ()=>(parcelRequire("j7wSR")),
    nb: ()=>(parcelRequire("8sbGb")),
    nl: ()=>(parcelRequire("dyIjf")),
    pl: ()=>(parcelRequire("3AT7D")),
    'pt-BR': ()=>(parcelRequire("j4fiL")),
    ru: ()=>(parcelRequire("iJyvz")),
    sk: ()=>(parcelRequire("6OeAs")),
    sl: ()=>(parcelRequire("et9TP")),
    sr: ()=>(parcelRequire("fJRcS")),
    'sr-RS': ()=>(parcelRequire("fMJLw")),
    'sr-YR': ()=>(parcelRequire("IeXPg")),
    sv: ()=>(parcelRequire("dKoAj")),
    th: ()=>(parcelRequire("78H9t")),
    tr: ()=>(parcelRequire("e63Aa")),
    uk: ()=>(parcelRequire("c5u43")),
    vi: ()=>(parcelRequire("gM64v")),
    zh: ()=>(parcelRequire("j6AaH")),
    'zh-TW': ()=>(parcelRequire("6HkXV"))
};


const $a5ea78601091ee04$export$6b89dea1a4334953 = (0, $gcpE0.createAsyncIntlProvider)({
    defaultMessages: (0, $7FdE1.default),
    asyncLanguages: $b8f2a3af0ad05925$export$3770c7a7737d463c
});


const $0bc646091c24cf0e$export$fe240e33002221f = 'global-shortcuts-platform-component';
const $0bc646091c24cf0e$export$2158b6d23c9689f5 = 'global-shortcuts-data-loading';


parcelRequire("cxAFf");
var $bVKFx = parcelRequire("bVKFx");


var $geKgP = parcelRequire("geKgP");


var $aXWIB = parcelRequire("aXWIB");

const $b137f7620a4b8ac1$export$628f6f7219a6b8b6 = (0, $aXWIB.defineMessages)({
    header: {
        id: "navigation.error.header.default",
        defaultMessage: "We couldn\u2019t load this content"
    },
    description: {
        id: "navigation.error.description.default",
        defaultMessage: "Refresh the page and try again"
    }
});



var $5hYae = parcelRequire("5hYae");








var $6bJyJ = parcelRequire("6bJyJ");







const $0b4de72332c147b6$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    viewAllAppsLabel: {
        id: "navigation.global-shortcuts.view-all-apps.label",
        defaultMessage: "View all apps"
    }
});


function $0b19012007f6ee0e$export$84e063904618ed06({ path: path, isSelected: isSelected, product: product, onNavigate: onNavigate }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const analyticsName = 'VIEW_ALL_APPS';
    if (!path || path.trim().length < 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5hYae.ShortcutMenuItem), {
        shortcut: {
            key: analyticsName,
            analyticsName: analyticsName,
            label: formatMessage((0, $0b4de72332c147b6$export$defe85febe8b728c).viewAllAppsLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                label: ""
            }),
            url: path,
            isReorderable: false,
            type: 'internal',
            isSelected: isSelected,
            onClick: onNavigate
        },
        product: product
    });
}


const $26f372a5788858af$export$9da1f15784a2a312 = $26f372a5788858af$var$GlobalShortcutsRelay;
const $26f372a5788858af$export$bae2da217bf9db6 = (0, $bedQP.componentWithFG)('navx-4463-gas-agg-migration', $26f372a5788858af$var$GlobalShortcutsRelay, $26f372a5788858af$var$GlobalShortcutsBFF);
function $26f372a5788858af$var$GlobalShortcutsRelay(props) {
    const { product: product } = props;
    const shouldUseErrorMessages = (0, $dh538.fg)('navx-4866-migrate-messages-from-nav-error-boundary');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: (0, $0bc646091c24cf0e$export$fe240e33002221f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5xxOu.NavErrorBoundary), {
        errorMessages: shouldUseErrorMessages ? (0, $b137f7620a4b8ac1$export$628f6f7219a6b8b6) : undefined,
        location: shouldUseErrorMessages ? undefined : (0, $dBtY8.ERROR_LOCATION__GLOBAL_SHORTCUTS),
        sentryConfig: {
            product: product
        },
        silent: true,
        ufoInteractionName: (0, $0bc646091c24cf0e$export$fe240e33002221f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26f372a5788858af$var$GlobalShortcutsInnerRelay, props)));
}
function $26f372a5788858af$var$GlobalShortcutsBFF(props) {
    const { product: product } = props;
    const shouldUseErrorMessages = (0, $dh538.fg)('navx-4866-migrate-messages-from-nav-error-boundary');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caUKj.BFFProvider), {
        consumer: (0, $4jETc.BFFConsumerEnum).GLOBAL_SHORTCUTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: (0, $0bc646091c24cf0e$export$fe240e33002221f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5xxOu.NavErrorBoundary), {
        errorMessages: shouldUseErrorMessages ? (0, $b137f7620a4b8ac1$export$628f6f7219a6b8b6) : undefined,
        location: shouldUseErrorMessages ? undefined : (0, $dBtY8.ERROR_LOCATION__GLOBAL_SHORTCUTS),
        sentryConfig: {
            product: product
        },
        silent: true,
        ufoInteractionName: (0, $0bc646091c24cf0e$export$fe240e33002221f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26f372a5788858af$var$GlobalShortcutsInnerBFF, props))));
}
function $26f372a5788858af$var$GlobalShortcutsInnerRelay({ cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab }) {
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)({
        location: (0, $dBtY8.ERROR_LOCATION__GLOBAL_SHORTCUTS),
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: product
        },
        disableAnalytics: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dZdq.default), {
        cloudId: cloudId,
        onError: handleError,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
        product: product,
        shortcutsConfig: rawShortcutItems
    }, (shortcutItems)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26f372a5788858af$export$d64b9883b9bde88c, {
            enableDragAndDrop: enableDragAndDrop,
            openInSameTab: openInSameTab,
            product: product,
            shortcutItems: shortcutItems,
            testId: testId,
            viewAllAppsConfig: viewAllAppsConfig
        }));
}
function $26f372a5788858af$var$GlobalShortcutsInnerBFF({ cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab }) {
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)({
        location: (0, $dBtY8.ERROR_LOCATION__GLOBAL_SHORTCUTS),
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: product
        },
        disableAnalytics: true
    });
    const shortcutItems = (0, $bVKFx.useGlobalShortcutsDataBFF)({
        shortcutsConfig: rawShortcutItems,
        cloudId: cloudId,
        onError: handleError,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
        product: product
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26f372a5788858af$export$d64b9883b9bde88c, {
        enableDragAndDrop: enableDragAndDrop,
        openInSameTab: openInSameTab,
        product: product,
        shortcutItems: shortcutItems,
        testId: testId,
        viewAllAppsConfig: viewAllAppsConfig
    });
}
function $26f372a5788858af$export$d64b9883b9bde88c({ testId: testId, shortcutItems: shortcutItems = [], product: product, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig = {}, openInSameTab: openInSameTab, intlMode: intlMode = 'async' }) {
    const IntlWrapper = intlMode === 'inherit' ? (0, $42omo.Fragment) : (0, $a5ea78601091ee04$export$6b89dea1a4334953);
    const mappedShortcutItems = (0, $42omo.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            let key = item.type === 'link' && item.apsKey || `shortcut-${index}`;
            if (item.type === 'component') key = item?.apsKey ?? item.menuItemId ?? `shortcut-${index}`;
            return {
                ...item,
                key: key
            };
        });
    }, [
        shortcutItems
    ]);
    const createLinkItem = (0, $42omo.useCallback)((shortcut)=>{
        if (shortcut.type === 'component') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5hYae.ShortcutMenuItem), {
            key: shortcut.key,
            shortcut: shortcut,
            dragAndDropEnabled: enableDragAndDrop
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5hYae.ShortcutMenuItem), {
            key: shortcut.key,
            shortcut: shortcut,
            openInSameTab: openInSameTab,
            product: product
        });
    }, [
        product,
        openInSameTab,
        enableDragAndDrop
    ]);
    const shortcutList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKHTh.MenuList), null, mappedShortcutItems?.map(createLinkItem), viewAllAppsConfig?.path && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0b19012007f6ee0e$export$84e063904618ed06), {
        ...viewAllAppsConfig,
        product: product
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IntlWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.NavigationAnalyticsContext), {
        data: {
            product: product
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        testId: testId
    }, enableDragAndDrop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $geKgP.DragAndDropOptionsProvider), {
        enabled: enableDragAndDrop
    }, shortcutList) : shortcutList)));
}
module.exports["GlobalShortcuts"] = $26f372a5788858af$export$bae2da217bf9db6;
module.exports["GlobalShortcutsMenu"] = $26f372a5788858af$export$d64b9883b9bde88c;

});

parcelRegister("7FdE1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a39680e968b16aaa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $4yBJM = parcelRequire("4yBJM");

var $a39680e968b16aaa$export$2e2bcd8739ae039 = (0, $4yBJM.default);

});

parcelRegister("efIgK", function(module, exports) {

let $a604ce4fe0c9e915$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a604ce4fe0c9e915$var$load("4Mixi"),
    $a604ce4fe0c9e915$var$load("1jsQH"),
    $a604ce4fe0c9e915$var$load("i5eMd"),
    $a604ce4fe0c9e915$var$load("bv8GZ"),
    $a604ce4fe0c9e915$var$load("i9sd0"),
    $a604ce4fe0c9e915$var$load("4DYJ5"),
    $a604ce4fe0c9e915$var$load("gyXEE"),
    $a604ce4fe0c9e915$var$load("hoPZ9")
]).then(()=>parcelRequire('br2f9'));

});

parcelRegister("hiUSM", function(module, exports) {

let $c9903dc8cf3a45b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c9903dc8cf3a45b9$var$load("cjveN"),
    $c9903dc8cf3a45b9$var$load("deyvi"),
    $c9903dc8cf3a45b9$var$load("4UPfH"),
    $c9903dc8cf3a45b9$var$load("cdeuH"),
    $c9903dc8cf3a45b9$var$load("aNg21"),
    $c9903dc8cf3a45b9$var$load("hfFxJ"),
    $c9903dc8cf3a45b9$var$load("1Mp9N"),
    $c9903dc8cf3a45b9$var$load("2Fu3d")
]).then(()=>parcelRequire('5T7BQ'));

});

parcelRegister("byGvB", function(module, exports) {

let $86a3d80b054b9d88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86a3d80b054b9d88$var$load("8XGJb"),
    $86a3d80b054b9d88$var$load("6dERU"),
    $86a3d80b054b9d88$var$load("gd4qs"),
    $86a3d80b054b9d88$var$load("7gF8f"),
    $86a3d80b054b9d88$var$load("YEGhv"),
    $86a3d80b054b9d88$var$load("gofGr"),
    $86a3d80b054b9d88$var$load("dBb6q"),
    $86a3d80b054b9d88$var$load("eJgH8")
]).then(()=>parcelRequire('f72Ys'));

});

parcelRegister("eWFBW", function(module, exports) {

let $ae16c285e4f9d202$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae16c285e4f9d202$var$load("aSjrK"),
    $ae16c285e4f9d202$var$load("03aeW")
]).then(()=>parcelRequire('9Uzok'));

});

parcelRegister("7OubI", function(module, exports) {

let $5b049e99b4483528$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b049e99b4483528$var$load("4ViGN"),
    $5b049e99b4483528$var$load("j0PWv"),
    $5b049e99b4483528$var$load("eBoC7"),
    $5b049e99b4483528$var$load("ksTQ6"),
    $5b049e99b4483528$var$load("j5F5K"),
    $5b049e99b4483528$var$load("7NpX8"),
    $5b049e99b4483528$var$load("cukQS"),
    $5b049e99b4483528$var$load("5FaEJ")
]).then(()=>parcelRequire('hFCKc'));

});

parcelRegister("i0vcp", function(module, exports) {

let $d1c06d98305c6b1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d1c06d98305c6b1f$var$load("32vlK"),
    $d1c06d98305c6b1f$var$load("dlmud"),
    $d1c06d98305c6b1f$var$load("bNv64"),
    $d1c06d98305c6b1f$var$load("5CGnz"),
    $d1c06d98305c6b1f$var$load("dXu4x"),
    $d1c06d98305c6b1f$var$load("bFU3Y"),
    $d1c06d98305c6b1f$var$load("3CucM"),
    $d1c06d98305c6b1f$var$load("9yemY")
]).then(()=>parcelRequire('kosLT'));

});

parcelRegister("i2aNt", function(module, exports) {

let $d210c9f7374a643f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d210c9f7374a643f$var$load("bjoGV"),
    $d210c9f7374a643f$var$load("cbkj0"),
    $d210c9f7374a643f$var$load("4Afgd"),
    $d210c9f7374a643f$var$load("9Oxgj"),
    $d210c9f7374a643f$var$load("18TX5"),
    $d210c9f7374a643f$var$load("exaJ2"),
    $d210c9f7374a643f$var$load("lp8Wm"),
    $d210c9f7374a643f$var$load("l2LZP")
]).then(()=>parcelRequire('ggDJR'));

});

parcelRegister("jKwpu", function(module, exports) {

let $e60b742f22be22ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e60b742f22be22ec$var$load("8oiz7"),
    $e60b742f22be22ec$var$load("17m16"),
    $e60b742f22be22ec$var$load("cMubu"),
    $e60b742f22be22ec$var$load("kAg8V"),
    $e60b742f22be22ec$var$load("9Cdzw"),
    $e60b742f22be22ec$var$load("hcCcg"),
    $e60b742f22be22ec$var$load("cHWSM"),
    $e60b742f22be22ec$var$load("35Ssm")
]).then(()=>parcelRequire('4f1t8'));

});

parcelRegister("ifns8", function(module, exports) {

let $d48bd1f85714d262$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d48bd1f85714d262$var$load("dXG9f").then(()=>parcelRequire('ewx5d'));

});

parcelRegister("k8eXM", function(module, exports) {

let $ea80295bf5b60443$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ea80295bf5b60443$var$load("hFxmj"),
    $ea80295bf5b60443$var$load("b4NO6"),
    $ea80295bf5b60443$var$load("3fLE9"),
    $ea80295bf5b60443$var$load("fM2oh"),
    $ea80295bf5b60443$var$load("guNAg"),
    $ea80295bf5b60443$var$load("j9KTb"),
    $ea80295bf5b60443$var$load("b37xN"),
    $ea80295bf5b60443$var$load("ik6u5")
]).then(()=>parcelRequire('3xm6B'));

});

parcelRegister("lPxfk", function(module, exports) {

let $fe48266a80d1230a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe48266a80d1230a$var$load("BXOZB"),
    $fe48266a80d1230a$var$load("1K1Fj"),
    $fe48266a80d1230a$var$load("8hOn0"),
    $fe48266a80d1230a$var$load("xnqy2"),
    $fe48266a80d1230a$var$load("cM3gY"),
    $fe48266a80d1230a$var$load("3hjAq"),
    $fe48266a80d1230a$var$load("7PjNK"),
    $fe48266a80d1230a$var$load("Vt6S9")
]).then(()=>parcelRequire('abc2w'));

});

parcelRegister("bk5cw", function(module, exports) {

let $83e598c12dcf831d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $83e598c12dcf831d$var$load("9Xiuh"),
    $83e598c12dcf831d$var$load("38sfA"),
    $83e598c12dcf831d$var$load("h4OCL"),
    $83e598c12dcf831d$var$load("awkVi"),
    $83e598c12dcf831d$var$load("6yRq3"),
    $83e598c12dcf831d$var$load("2bCHJ"),
    $83e598c12dcf831d$var$load("ktSfi"),
    $83e598c12dcf831d$var$load("9GZ76")
]).then(()=>parcelRequire('iOsEl'));

});

parcelRegister("j7wSR", function(module, exports) {

let $deb82dd54aafd96c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $deb82dd54aafd96c$var$load("7Odo3"),
    $deb82dd54aafd96c$var$load("bjmre"),
    $deb82dd54aafd96c$var$load("bcQs2"),
    $deb82dd54aafd96c$var$load("11DLa"),
    $deb82dd54aafd96c$var$load("cft22"),
    $deb82dd54aafd96c$var$load("fdXnq"),
    $deb82dd54aafd96c$var$load("iouLY"),
    $deb82dd54aafd96c$var$load("4sOIV")
]).then(()=>parcelRequire('aIqdH'));

});

parcelRegister("8sbGb", function(module, exports) {

let $6279ff85da2b74d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6279ff85da2b74d2$var$load("4VkvT"),
    $6279ff85da2b74d2$var$load("asvK9"),
    $6279ff85da2b74d2$var$load("aBa7j"),
    $6279ff85da2b74d2$var$load("barSq"),
    $6279ff85da2b74d2$var$load("gctEz"),
    $6279ff85da2b74d2$var$load("cItJR"),
    $6279ff85da2b74d2$var$load("hPZE5"),
    $6279ff85da2b74d2$var$load("QTjdE")
]).then(()=>parcelRequire('6B9u2'));

});

parcelRegister("dyIjf", function(module, exports) {

let $9df0d2445f5537c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9df0d2445f5537c5$var$load("g5qJV"),
    $9df0d2445f5537c5$var$load("7v6wU"),
    $9df0d2445f5537c5$var$load("b544F"),
    $9df0d2445f5537c5$var$load("a8heY"),
    $9df0d2445f5537c5$var$load("9PPH7"),
    $9df0d2445f5537c5$var$load("SctKm"),
    $9df0d2445f5537c5$var$load("dzIm8"),
    $9df0d2445f5537c5$var$load("hrf1M")
]).then(()=>parcelRequire('bZefw'));

});

parcelRegister("3AT7D", function(module, exports) {

let $29df7e006ff6c0b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $29df7e006ff6c0b0$var$load("dPa6p"),
    $29df7e006ff6c0b0$var$load("aEpRh"),
    $29df7e006ff6c0b0$var$load("K6fhx"),
    $29df7e006ff6c0b0$var$load("6hlNE"),
    $29df7e006ff6c0b0$var$load("1y1eN"),
    $29df7e006ff6c0b0$var$load("1fJz1"),
    $29df7e006ff6c0b0$var$load("jqwnR"),
    $29df7e006ff6c0b0$var$load("lsloj")
]).then(()=>parcelRequire('kzj9p'));

});

parcelRegister("j4fiL", function(module, exports) {

let $de1a42a0f9bf2573$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $de1a42a0f9bf2573$var$load("iG4uh"),
    $de1a42a0f9bf2573$var$load("3fuR9"),
    $de1a42a0f9bf2573$var$load("gZU54"),
    $de1a42a0f9bf2573$var$load("2bqSD"),
    $de1a42a0f9bf2573$var$load("e8jpx"),
    $de1a42a0f9bf2573$var$load("9yA8o"),
    $de1a42a0f9bf2573$var$load("bGhLc"),
    $de1a42a0f9bf2573$var$load("iRKhU")
]).then(()=>parcelRequire('5JjoD'));

});

parcelRegister("iJyvz", function(module, exports) {

let $da3732952e4738af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $da3732952e4738af$var$load("9tVE8"),
    $da3732952e4738af$var$load("fMrUo"),
    $da3732952e4738af$var$load("4Wdqb"),
    $da3732952e4738af$var$load("bJykp"),
    $da3732952e4738af$var$load("fjbzp"),
    $da3732952e4738af$var$load("448N7"),
    $da3732952e4738af$var$load("9v6ER"),
    $da3732952e4738af$var$load("aEAsN")
]).then(()=>parcelRequire('kJ9vR'));

});

parcelRegister("6OeAs", function(module, exports) {

let $4f52ba441df45971$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f52ba441df45971$var$load("j5Twc").then(()=>parcelRequire('5lFLc'));

});

parcelRegister("et9TP", function(module, exports) {

let $a88b73ec8c592ac6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a88b73ec8c592ac6$var$load("4Mrbu").then(()=>parcelRequire('9ULKs'));

});

parcelRegister("fJRcS", function(module, exports) {

let $b75454bafcaad952$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b75454bafcaad952$var$load("7FTFD").then(()=>parcelRequire('cbT8e'));

});

parcelRegister("fMJLw", function(module, exports) {

let $b7ded6c5c0f845e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7ded6c5c0f845e2$var$load("kot8G").then(()=>parcelRequire('2myNX'));

});

parcelRegister("IeXPg", function(module, exports) {

let $084fb7b3874d3e8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $084fb7b3874d3e8c$var$load("jHV54").then(()=>parcelRequire('aul34'));

});

parcelRegister("dKoAj", function(module, exports) {

let $a022a44411042ed7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a022a44411042ed7$var$load("6UAlo"),
    $a022a44411042ed7$var$load("9eNkX"),
    $a022a44411042ed7$var$load("k10Cs"),
    $a022a44411042ed7$var$load("dh2Er"),
    $a022a44411042ed7$var$load("1pFHs"),
    $a022a44411042ed7$var$load("gBDdh"),
    $a022a44411042ed7$var$load("8Mz40"),
    $a022a44411042ed7$var$load("l6YHr")
]).then(()=>parcelRequire('vKazA'));

});

parcelRegister("78H9t", function(module, exports) {

let $532ac0d0a30e5dbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $532ac0d0a30e5dbf$var$load("fdczG"),
    $532ac0d0a30e5dbf$var$load("6nK39")
]).then(()=>parcelRequire('3GtCy'));

});

parcelRegister("e63Aa", function(module, exports) {

let $a43467985c6d32a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a43467985c6d32a2$var$load("epkdv"),
    $a43467985c6d32a2$var$load("hWNfo")
]).then(()=>parcelRequire('72BhT'));

});

parcelRegister("c5u43", function(module, exports) {

let $8ccd45d65bf67c8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ccd45d65bf67c8e$var$load("3MGOs"),
    $8ccd45d65bf67c8e$var$load("8UuQQ")
]).then(()=>parcelRequire('6yNb3'));

});

parcelRegister("gM64v", function(module, exports) {

let $c365d6c2c8c7b614$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c365d6c2c8c7b614$var$load("innCz"),
    $c365d6c2c8c7b614$var$load("6BkMx")
]).then(()=>parcelRequire('74VfG'));

});

parcelRegister("j6AaH", function(module, exports) {

let $de8aa2c815ad3740$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $de8aa2c815ad3740$var$load("15ncj"),
    $de8aa2c815ad3740$var$load("gDiIK"),
    $de8aa2c815ad3740$var$load("f1B4n"),
    $de8aa2c815ad3740$var$load("eLlpV"),
    $de8aa2c815ad3740$var$load("7sItg"),
    $de8aa2c815ad3740$var$load("j4dSZ"),
    $de8aa2c815ad3740$var$load("1Tuyb"),
    $de8aa2c815ad3740$var$load("7iCpI")
]).then(()=>parcelRequire('hc8vA'));

});

parcelRegister("6HkXV", function(module, exports) {

let $4e07058a1f0f6a43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e07058a1f0f6a43$var$load("ia9y3"),
    $4e07058a1f0f6a43$var$load("j9OUx"),
    $4e07058a1f0f6a43$var$load("l079e"),
    $4e07058a1f0f6a43$var$load("bV8sS"),
    $4e07058a1f0f6a43$var$load("kKXTS"),
    $4e07058a1f0f6a43$var$load("ebljE"),
    $4e07058a1f0f6a43$var$load("hF4v3"),
    $4e07058a1f0f6a43$var$load("afU9w")
]).then(()=>parcelRequire('hP4wC'));

});

parcelRegister("5hYae", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $bedQP = parcelRequire("bedQP");


var $5xxOu = parcelRequire("5xxOu");


var $gFauz = parcelRequire("gFauz");





var $3654r = parcelRequire("3654r");


var $fdzcy = parcelRequire("fdzcy");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * This code is copied from packages/design-system/navigation-system/src/ui/menu-item/menu-item.tsx
 */ 



var $1bHXt = parcelRequire("1bHXt");


var $gdv5Z = parcelRequire("gdv5Z");


var $6xzqO = parcelRequire("6xzqO");

// Note: this is also used in `drag-handle.tsx`
const $f5665acef440f160$var$dragHandleDisplayVar = '--drag-handle-display';
const $f5665acef440f160$var$dragCursorAnimation = null;
const $f5665acef440f160$var$topLevelSiblingStyles = {
    root: "_kqswh2mm _1e0c1txw _2lx21bp4"
};
const $f5665acef440f160$var$styles = {
    hasDragIndicator: "_1ifmglyw _1cykglyw _e0jc1txw _fxw76b4r _avx0ru3m _1rnc1amc _132yq7pw"
};
function $f5665acef440f160$export$f9bcea5c2cbf8443({ children: children, hasDragIndicator: hasDragIndicator }) {
    if (hasDragIndicator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1bHXt.cx)($f5665acef440f160$var$topLevelSiblingStyles.root, $f5665acef440f160$var$styles.hasDragIndicator)
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xzqO.DragHandle), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}


var $3H0hg = parcelRequire("3H0hg");

const $93fe23303aa3f056$var$isMenuComponentDraggableItemConfig = (shortcut)=>{
    return !!(shortcut?.isReorderable && shortcut?.menuItemId);
};
function $93fe23303aa3f056$export$9de4dadf420d5c24({ shortcut: shortcut, onClick: onClick, dragAndDropEnabled: dragAndDropEnabled, isInMoreMenu: isInMoreMenu }) {
    const handleClick = (0, $42omo.useCallback)(()=>{
        onClick?.();
        shortcut.onClick?.();
    }, [
        onClick,
        shortcut
    ]);
    if (dragAndDropEnabled && $93fe23303aa3f056$var$isMenuComponentDraggableItemConfig(shortcut)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93fe23303aa3f056$var$MenuComponentDraggableItem, {
        shortcut: shortcut,
        onClick: handleClick,
        isInMoreMenu: isInMoreMenu
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93fe23303aa3f056$var$MenuComponentNonDraggableItem, {
        onClick: handleClick,
        shortcut: shortcut,
        isInMoreMenu: isInMoreMenu
    });
}
function $93fe23303aa3f056$var$MenuComponentNonDraggableItem({ shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu }) {
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    const Component = shortcut.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        onClick: onClick,
        isInMoreMenu: isInMoreMenu
    }));
}
function $93fe23303aa3f056$var$MenuComponentDraggableItem({ shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu }) {
    const Component = shortcut.component;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $42omo.useState)(false);
    const onExpandFlyoutToggle = (0, $42omo.useCallback)((open)=>{
        setIsExpandOrFlyoutOpen(open);
    }, []);
    const hookProps = (0, $42omo.useMemo)(()=>({
            id: shortcut.menuItemId,
            isExpandable: true,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            l1DragAndDropEnabled: true,
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            peek: false,
            item: {
                type: 'custom',
                elemBefore: null,
                label: shortcut.label,
                labelElem: shortcut.labelElem,
                isReorderable: shortcut.isReorderable,
                Component: Component,
                isDraggable: true
            },
            group: (0, $fdzcy.L1_MENU_GROUPS).SHORTCUTS
        }), [
        shortcut.label,
        shortcut.menuItemId,
        shortcut.labelElem,
        Component,
        shortcut.isReorderable,
        isExpandOrFlyoutOpen,
        onExpandFlyoutToggle
    ]);
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $3H0hg.useL1ItemDragAndDrop)(hookProps);
    if (draggableRef === undefined || dropIndicator === undefined || dropTargetRef === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93fe23303aa3f056$var$MenuComponentNonDraggableItem, {
        shortcut: shortcut,
        onClick: onClick,
        isInMoreMenu: isInMoreMenu
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5665acef440f160$export$f9bcea5c2cbf8443), {
        hasDragIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        draggableRef: (0, $3654r.default)([
            draggableRef,
            shortcut?.ref
        ]),
        dropIndicator: dropIndicator,
        hasDragIndicator: true,
        isDragging: isDragging,
        visualContentRef: dropTargetRef,
        onClick: onClick,
        isInMoreMenu: isInMoreMenu,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle
    })), maybeDragPreview);
}






var $39XmP = parcelRequire("39XmP");





var $7TH2w = parcelRequire("7TH2w");








var $8tdj3 = parcelRequire("8tdj3");


var $dh538 = parcelRequire("dh538");





var $9x2sR = parcelRequire("9x2sR");








var $culkJ = parcelRequire("culkJ");





var $fFa3V = parcelRequire("fFa3V");

const $5b328a77149103a7$export$8209b3c2d1620841 = ({ onFocus: onFocus, onMouseEnter: onMouseEnter, onRightClick: onRightClick, children: children })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!wrapperRef.current || !onRightClick) return;
        const handleMouseDown = (e)=>{
            const isLink = e.target.closest('a');
            if (isLink && e.button !== 0) onRightClick();
        };
        const unbind = (0, $fFa3V.bind)(wrapperRef.current, {
            type: 'mousedown',
            listener: handleMouseDown
        });
        return unbind;
    }, [
        onRightClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: wrapperRef,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        "data-vc": "jt2njUHI"
    }, children);
};






var $geKgP = parcelRequire("geKgP");

function $dd4485e00eedab96$export$eae7963fc47ca0d0() {
    const context = (0, $42omo.useContext)((0, $geKgP.DragAndDropOptionsContext));
    if (!context) return {
        enabled: false
    };
    return {
        enabled: context.enabled
    };
}















var $1qfLF = parcelRequire("1qfLF");


var $g5gZt = parcelRequire("g5gZt");


var $56M4r = parcelRequire("56M4r");

var $2SlZp = parcelRequire("2SlZp");





var $lGgRw = parcelRequire("lGgRw");







const $bae1ab3d84e6d86e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    shortcutActionOpenMenuLabel: {
        id: "navigation.global-shortcuts.shortcut-action.open-menu-label",
        defaultMessage: "open menu"
    }
});


const $d6eb3e10d21d0abb$export$7e648395389e18b0 = ({ actions: actions, analyticsName: analyticsName })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const handleClick = (0, $42omo.useCallback)(()=>{
        setIsOpen(true);
        $d6eb3e10d21d0abb$var$fireShortcutActionMenuClickedAnalyticsEvent(createAnalyticsEvent, analyticsName);
    }, [
        createAnalyticsEvent,
        analyticsName,
        setIsOpen
    ]);
    const handleDropdownItemClick = (0, $42omo.useCallback)((itemId)=>{
        $d6eb3e10d21d0abb$var$fireShortcutActionDropdownItemClickedAnalyticsEvent(createAnalyticsEvent, itemId);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d6eb3e10d21d0abb$var$ButtonItemWithAnalytics, {
                    index: index,
                    action: action,
                    fireShortcutActionDropdownItemClickedAnalyticsEvent: handleDropdownItemClick,
                    setIsOpen: setIsOpen
                }))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage((0, $bae1ab3d84e6d86e$export$defe85febe8b728c).shortcutActionOpenMenuLabel),
                onClick: handleClick
            })
    });
};
const $d6eb3e10d21d0abb$var$ButtonItemWithAnalytics = ({ index: index, action: action, fireShortcutActionDropdownItemClickedAnalyticsEvent: fireShortcutActionDropdownItemClickedAnalyticsEvent, setIsOpen: setIsOpen })=>{
    const handleClick = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        action.onClick?.();
        if ((0, $dh538.fg)('navx-global-side-nav-confluence')) fireShortcutActionDropdownItemClickedAnalyticsEvent(action.itemId);
        setIsOpen(false);
    }, [
        action,
        fireShortcutActionDropdownItemClickedAnalyticsEvent,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        key: index,
        onClick: handleClick
    }, action.component);
};
const $d6eb3e10d21d0abb$var$fireShortcutActionMenuClickedAnalyticsEvent = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'ShortcutActionMenu',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $culkJ.ANALYTICS_CHANNEL));
};
const $d6eb3e10d21d0abb$var$fireShortcutActionDropdownItemClickedAnalyticsEvent = (createAnalyticsEvent, itemId)=>{
    createAnalyticsEvent({
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'ShortcutActionDropdownItem',
        attributes: {
            itemId: itemId
        }
    }).fire((0, $culkJ.ANALYTICS_CHANNEL));
};





const $d7199daead2261d0$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    linkExternalIconLabel: {
        id: "navigation.global-shortcuts.menu-link-item.link-external-item-label",
        defaultMessage: "Open external link icon"
    }
});


const $38975b5be28224a9$export$18a13ecc162cd5c2 = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'globalNavigation',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $culkJ.ANALYTICS_CHANNEL));
};
/**
 * Utility to return whether actions and options should be shown
 */ const $38975b5be28224a9$var$getShouldShowActionsAndOptions = (actions, optionsMenuElem)=>actions && actions.length >= 0 || !!optionsMenuElem;
/**
 * Actions and Options component to render both the action menu and options menu
 * beside each other on hover/focus
 */ const $38975b5be28224a9$var$ActionsAndOptions = ({ actions: actions, analyticsName: analyticsName, optionsMenuElem: optionsMenuElem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, actions && actions.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d6eb3e10d21d0abb$export$7e648395389e18b0), {
        actions: actions,
        analyticsName: analyticsName
    }), optionsMenuElem);
const $38975b5be28224a9$var$MenuLinkItemComponent = ({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, optionalRef: optionalRef, isSelected: isSelected, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const mergedRefs = (0, $3654r.default)(optionalRef ? [
        optionalRef
    ] : []);
    const shouldShowActionsAndOptions = $38975b5be28224a9$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
        actionsOnHover: shouldShowActionsAndOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($38975b5be28224a9$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        }),
        elemBefore: icon,
        elemAfter: !openInSameTab && ((0, $dh538.fg)('navx-4022-gas-icons-a11y-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: formatMessage((0, $d7199daead2261d0$export$defe85febe8b728c).linkExternalIconLabel),
            size: "small",
            spacing: "spacious"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: formatMessage((0, $d7199daead2261d0$export$defe85febe8b728c).linkExternalIconLabel),
            size: "small",
            spacing: "spacious"
        })),
        href: url || '',
        target: openInSameTab ? '_self' : '_blank',
        onClick: onClick,
        ref: mergedRefs,
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "aria-label": ariaLabel,
        "data-vc": "HrFoNe4t"
    }, labelElem ?? label));
};
const $38975b5be28224a9$var$MenuLinkItemDraggableComponent = ({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, isReorderable: isReorderable, optionalRef: optionalRef, menuItemId: menuItemId, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName, isSelected: isSelected })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { enabled: enabled } = (0, $dd4485e00eedab96$export$eae7963fc47ca0d0)();
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $3H0hg.useL1ItemDragAndDrop)({
        id: menuItemId,
        isExpandable: false,
        isExpandOrFlyoutOpen: false,
        l1DragAndDropEnabled: enabled,
        onExpandFlyoutToggle: ()=>{},
        peek: false,
        item: {
            type: 'link',
            elemBefore: icon,
            label: label,
            labelElem: labelElem,
            href: url || '',
            isReorderable: isReorderable
        },
        group: (0, $fdzcy.L1_MENU_GROUPS).SHORTCUTS
    });
    // Can possibly be undefined
    const draggableRefCollection = draggableRef ? [
        draggableRef
    ] : [];
    const mergedRefs = (0, $3654r.default)(optionalRef ? [
        optionalRef,
        ...draggableRefCollection
    ] : [
        ...draggableRefCollection
    ]);
    const shouldShowActionsAndOptions = $38975b5be28224a9$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
        isDragging: isDragging,
        hasDragIndicator: true,
        ref: mergedRefs,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef,
        actionsOnHover: shouldShowActionsAndOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($38975b5be28224a9$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        }),
        elemBefore: icon,
        elemAfter: !openInSameTab && ((0, $dh538.fg)('navx-4022-gas-icons-a11y-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: formatMessage((0, $d7199daead2261d0$export$defe85febe8b728c).linkExternalIconLabel),
            size: "small",
            spacing: "spacious"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: formatMessage((0, $d7199daead2261d0$export$defe85febe8b728c).linkExternalIconLabel),
            size: "small",
            spacing: "spacious"
        })),
        href: url || '',
        target: openInSameTab ? '_self' : '_blank',
        isSelected: isSelected,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "aria-label": ariaLabel
    }, labelElem ?? label)), maybeDragPreview);
};
const $38975b5be28224a9$export$68ef190193a37bc2 = ({ analyticsName: analyticsName, url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, onRightClick: onRightClick, onFocus: onFocus, onMouseEnter: onMouseEnter, optionalRef: optionalRef, isReorderable: isReorderable, menuItemId: menuItemId, isSelected: isSelected, product: product = 'globalNavigation', openInSameTab: openInSameTab })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { enabled: enabled } = (0, $dd4485e00eedab96$export$eae7963fc47ca0d0)();
    const analyticsUrlWrapper = (0, $39XmP.default)({
        bridge: 'globalShortcuts',
        product: product
    });
    const getTargetUrl = (0, $42omo.useCallback)((url)=>{
        // For SPA links, we don't want to wrap the URL
        if (!$38975b5be28224a9$var$isValidUrl(url)) return url;
        try {
            const parsedUrl = new URL(url);
            const continueParam = parsedUrl.searchParams.get('continue');
            if (!continueParam) // If there is no continue param, we just wrap the whole URL
            return analyticsUrlWrapper(url);
            // Safely deserialize identity links e.g: https://id.atlassian.com/login?login_hint=...
            const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
            // Reconstruct the original URL with the wrapped continue param
            parsedUrl.searchParams.set('continue', wrappedContinueUrl);
            return parsedUrl.toString();
        } catch  {
            // Gracefully handle any URL parsing errors by returning the original URL
            // TODO: Log error to Sentry
            return url;
        }
    }, [
        analyticsUrlWrapper
    ]);
    const onClickMenuLinkItem = (0, $42omo.useCallback)((event)=>{
        $38975b5be28224a9$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
        onClick?.(event);
    }, [
        createAnalyticsEvent,
        analyticsName,
        onClick
    ]);
    if (!url) return null;
    const targetUrl = getTargetUrl(url);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5b328a77149103a7$export$8209b3c2d1620841), {
        onRightClick: onRightClick,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus
    }, enabled && menuItemId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($38975b5be28224a9$var$MenuLinkItemDraggableComponent, {
        optionalRef: optionalRef,
        url: targetUrl,
        icon: icon,
        ariaLabel: ariaLabel,
        label: label,
        labelElem: labelElem,
        actions: actions,
        onClick: onClickMenuLinkItem,
        isReorderable: isReorderable,
        isSelected: isSelected,
        menuItemId: menuItemId,
        openInSameTab: openInSameTab
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($38975b5be28224a9$var$MenuLinkItemComponent, {
        optionalRef: optionalRef,
        url: targetUrl,
        icon: icon,
        ariaLabel: ariaLabel,
        label: label,
        labelElem: labelElem,
        actions: actions,
        onClick: onClickMenuLinkItem,
        isReorderable: isReorderable,
        isSelected: isSelected,
        openInSameTab: openInSameTab
    }));
};
const $38975b5be28224a9$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch  {
        return false;
    }
};





const $7614326872455d2b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    menuLinkItemAriaLabel: {
        id: "navigation.global-shortcuts.shortcut-link-item.aria-label",
        defaultMessage: "{appName}{siteName}"
    }
});
const $7614326872455d2b$export$b010a30b3233e0c5 = (0, $aXWIB.defineMessages)({
    header: {
        id: "navigation.global-shortcuts.error.header",
        defaultMessage: "We couldn\u2019t load the shortcut for {menuId}"
    },
    description: {
        id: "navigation.global-shortcuts.error.description",
        defaultMessage: "Refresh the page and try again"
    }
});


const $5a702e671347a15f$export$ca0f90d95927cf81 = (0, $bedQP.componentWithFG)('navx-4866-migrate-messages-from-nav-error-boundary', $5a702e671347a15f$var$ShortcutMenuItemWithErrorBoundary, $5a702e671347a15f$var$ShortcutMenuItemWithoutErrorBoundary);
const $5a702e671347a15f$export$af94fce1535255cc = /*#__PURE__*/ (0, $42omo.memo)($5a702e671347a15f$export$ca0f90d95927cf81);
function $5a702e671347a15f$var$ShortcutMenuItemWithErrorBoundary(props) {
    const menuId = props.shortcut.key;
    const errorMessageValues = (0, $42omo.useMemo)(()=>({
            menuId: menuId
        }), [
        menuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5xxOu.NavErrorBoundary), {
        key: menuId,
        errorMessages: (0, $7614326872455d2b$export$b010a30b3233e0c5),
        errorMessageValues: errorMessageValues,
        showFlags: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a702e671347a15f$var$ShortcutMenuItemWithoutErrorBoundary, props));
}
/** Unmemoized implementation; exported for tests that assert render counts. */ function $5a702e671347a15f$var$ShortcutMenuItemWithoutErrorBoundary({ shortcut: shortcut, dragAndDropEnabled: dragAndDropEnabled, product: product, openInSameTab: openInSameTab, isInMoreMenu: isInMoreMenu }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const labelText = shortcut.label;
    const analyticsName = shortcut.analyticsName || `unknown_${labelText}`;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    const customComponentDraggableOnClick = (0, $42omo.useCallback)(()=>{
        (0, $38975b5be28224a9$export$18a13ecc162cd5c2)(createAnalyticsEvent, analyticsName);
    }, [
        analyticsName,
        createAnalyticsEvent
    ]);
    if (shortcut.type === 'component') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $93fe23303aa3f056$export$9de4dadf420d5c24), {
        shortcut: shortcut,
        dragAndDropEnabled: dragAndDropEnabled,
        isInMoreMenu: isInMoreMenu,
        onClick: customComponentDraggableOnClick
    });
    if (shortcut.type === 'internal') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $38975b5be28224a9$export$68ef190193a37bc2), {
        analyticsName: analyticsName,
        key: shortcut.key,
        icon: shortcut.icon,
        isSelected: shortcut.isSelected,
        isReorderable: shortcut.isReorderable,
        label: labelText,
        labelElem: shortcut.labelElem,
        openInSameTab: true,
        onClick: shortcut.onClick,
        onRightClick: shortcut.onRightClick,
        product: product,
        url: (0, $gFauz.getUrlMaybe)(shortcut)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $38975b5be28224a9$export$68ef190193a37bc2), {
        actions: shortcut.actions,
        analyticsName: analyticsName,
        ariaLabel: formatMessage((0, $7614326872455d2b$export$defe85febe8b728c).menuLinkItemAriaLabel, {
            appName: labelText,
            siteName: ''
        }),
        icon: shortcut.icon,
        isReorderable: shortcut.isReorderable,
        key: shortcut.key,
        label: labelText,
        labelElem: shortcut.labelElem,
        menuItemId: shortcut.menuItemId,
        onClick: shortcut.onClick,
        onFocus: shortcut.onFocus,
        onMouseEnter: shortcut.onMouseEnter,
        onRightClick: shortcut.onRightClick,
        openInSameTab: openInSameTab,
        optionalRef: shortcut.ref,
        optionsMenuElem: shortcut.optionsMenuElem,
        product: product,
        url: (0, $gFauz.getUrlMaybe)(shortcut)
    }));
}
module.exports["ShortcutMenuItem"] = $5a702e671347a15f$export$af94fce1535255cc;

});

parcelRegister("gFauz", function(module, exports) {
const $2608e69a137afd0b$export$739b3f561aa47bc9 = (fallbackUrl)=>{
    if (typeof fallbackUrl === 'function') return fallbackUrl();
    // `fallbackUrl` is a string, return it directly
    return fallbackUrl;
};


const $7835b86ae1a8768a$export$1f32ba41e2b31f39 = (fallbackUrl)=>{
    if (fallbackUrl === undefined) return undefined;
    return (0, $2608e69a137afd0b$export$739b3f561aa47bc9)(fallbackUrl);
};


const $46397dd2e0c2b3dd$export$ac51fdc0c7ed862d = (options)=>options.url || (0, $7835b86ae1a8768a$export$1f32ba41e2b31f39)(options.fallbackUrl);
module.exports["getUrlMaybe"] = $46397dd2e0c2b3dd$export$ac51fdc0c7ed862d;

});

parcelRegister("bVKFx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hwDTW = parcelRequire("hwDTW");


var $dh538 = parcelRequire("dh538");





var $4jETc = parcelRequire("4jETc");


var $6lFYf = parcelRequire("6lFYf");


var $6Tx9o = parcelRequire("6Tx9o");





var $g58eM = parcelRequire("g58eM");


var $lzcvT = parcelRequire("lzcvT");




function $c62ed403d6258f10$export$3e8bbf689f8e6cad(record, sortFunction) {
    for(const key in record)if (Array.isArray(record[key])) record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
    return record;
}






var $aXWIB = parcelRequire("aXWIB");

const $abc574e5bd82b638$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), text);
};
const $abc574e5bd82b638$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };
const $abc574e5bd82b638$export$e57a6793604f15ac = (atiArray)=>{
    return atiArray && atiArray.length > 0 ? atiArray.join(',') : undefined;
};






var $ik19A = parcelRequire("ik19A");

function $e49dbd0b56d8db18$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $e49dbd0b56d8db18$var$flightdeckClient = new (0, $g58eM.default)('atlassian-navigagtion-bff-data-provider');
function $e49dbd0b56d8db18$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: items } = (0, $6Tx9o.useCache)();
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [fdResponse, setFdResponse] = (0, $42omo.useState)(null);
    const [productConfig, setProductConfig] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse = await $e49dbd0b56d8db18$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $lzcvT.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch  {
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse && !forceStatic) getFlightdeckData();
    }, [
        fdResponse,
        setStatus,
        forceStatic
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $abc574e5bd82b638$export$905fe28a7c283e1d)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $abc574e5bd82b638$export$905fe28a7c283e1d)(rebrandedDisplayName),
                description: (0, $abc574e5bd82b638$export$905fe28a7c283e1d)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $4jETc.ASSETS_APP_KEY]) config[0, $4jETc.ASSETS_APP_KEY] = {
                key: (0, $4jETc.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                label: (0, $abc574e5bd82b638$export$905fe28a7c283e1d)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $42omo.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $42omo.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType })=>$e49dbd0b56d8db18$var$checkShouldRemoveJWM(productType));
        });
        items.forEach((item)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl, displayName: displayName, org: org } = item;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product)=>{
                const { url: productUrl } = product;
                let { productType: productType } = product;
                const isExcludeJiraBusiness = productType === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType = 'JIRA_SOFTWARE';
                if (!products[productType]) products[productType] = [];
                if (!isExcludeJiraBusiness) products[productType].push({
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    displayName: displayName,
                    url: getProductLinkForItem(productType, siteUrl, productUrl),
                    avatar: avatar,
                    cloudId: cachedItemCloudId
                });
            });
        });
        return (0, $c62ed403d6258f10$export$3e8bbf689f8e6cad)(products, (a, b)=>{
            return (0, $abc574e5bd82b638$export$60f5d4abb43a14b3)('asc')(a.displayName, b.displayName);
        });
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}






var $cdX3N = parcelRequire("cdX3N");

async function $f19027b153d497cf$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $f19027b153d497cf$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId, product: product, userId: userId, forceStatic: forceStatic }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $6Tx9o.useCache)();
    const { status: status, error: error, setStatus: setStatus } = (0, $ik19A.useStatus)();
    const { productLinks: productLinks } = (0, $e49dbd0b56d8db18$export$79322ba781a26ce1)({
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const { buildURL: buildURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId,
        userId: userId,
        product: product
    });
    const currentRequest = (0, $42omo.useRef)(null);
    const fetchData = (0, $42omo.useCallback)(async (url, data, attemptCount = 1, successCheck)=>{
        if (url === '') throw new Error('URL is empty');
        // Always clear error status at the start of a new request
        setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.BFF_REQUEST_STATUS_KEY), undefined);
        try {
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            switch(response.status){
                case (0, $4jETc.RequestStatus).ERROR:
                    throw response.error;
                case (0, $4jETc.RequestStatus).COMPLETE:
                    setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.BFF_REQUEST_STATUS_KEY), undefined);
                    currentRequest.current = null;
                    return response.data;
            }
        } catch (error) {
            const maxAttempts = request?.maxAttempts ?? (0, $4jETc.MAX_ATTEMPTS_NEW_DEFAULT);
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                const baseInterval = request?.attemptInterval ?? (0, $4jETc.RETRY_INTERVAL_DEFAULT);
                // Exponential backoff: delay doubles with each attempt (1x, 2x, 4x)
                const delay = request?.enableExponentialDelay ? baseInterval * Math.pow(2, attemptCount - 1) : baseInterval;
                await $f19027b153d497cf$var$wait(delay);
                return await fetchData(url, data, attemptCount + 1, successCheck);
            } else {
                currentRequest.current = null;
                setStatus((0, $4jETc.RequestStatus).ERROR, undefined, error instanceof Error ? error : new Error(String(error)));
                throw error;
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        request?.enableExponentialDelay,
        setStatus
    ]);
    /**
	 * Helper function to build a URL and fetch data.
	 */ const buildURLAndFetchData = (0, $42omo.useCallback)(async ()=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({});
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl, undefined, undefined, undefined);
            const fetchedData = await currentRequest.current;
            if (!!fetchedData?.sites?.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        error: error,
        status: status,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}



var $culkJ = parcelRequire("culkJ");

const $c124c8c0b6cfb1b3$export$54a1da5292674ec8 = (workspaceCloudId)=>(item, index, arr)=>{
        const matchedItem = arr.find((productLink)=>{
            return productLink.cloudId === workspaceCloudId;
        });
        // If an item exists in the parent array with the same cloudId,
        // we don't want to show a flyout and instead only want the list
        // of available product links to include the matching cloudId.
        if (matchedItem) return workspaceCloudId === item.cloudId;
        // If the filter gets here we want to only pass the first item
        return index === 0;
    };


const $77ed2a31de36ddab$export$716312c3742c01a3 = ({ shortcutsConfig: shortcutsConfig, cloudId: cloudId, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, isShortcutsStatic: isShortcutsStatic, onError: onError })=>{
    const onUpdateGetFilteredProductLinksRef = (0, $42omo.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks, error: error } = (0, $f19027b153d497cf$export$a00b492c9c3c66db)({
        request: {},
        cloudId: cloudId,
        forceStatic: isShortcutsStatic,
        product: product
    });
    const productLinksRef = (0, $42omo.useRef)(productLinks);
    productLinksRef.current = productLinks;
    const statusRef = (0, $42omo.useRef)(status);
    statusRef.current = status;
    const lastCompleteProductLinksRef = (0, $42omo.useRef)({});
    if (status === (0, $culkJ.RequestStatus).COMPLETE) lastCompleteProductLinksRef.current = {
        ...productLinks
    };
    const getBffProductLinksForKey = (0, $42omo.useCallback)((apsKey)=>({
            links: ((0, $dh538.fg)('navx-gas-getlink-unstable-fix') ? lastCompleteProductLinksRef.current : productLinksRef.current)[apsKey] ?? [],
            status: (0, $dh538.fg)('navx-gas-getlink-unstable-fix') ? (0, $culkJ.RequestStatus).COMPLETE : statusRef.current
        }), []);
    (0, $42omo.useEffect)(()=>{
        if (!onUpdateGetFilteredProductLinksRef.current) return;
        if (status !== (0, $culkJ.RequestStatus).COMPLETE && (0, $dh538.fg)('navx-gas-getlink-unstable-fix')) return;
        onUpdateGetFilteredProductLinksRef.current(getBffProductLinksForKey);
    }, [
        getBffProductLinksForKey,
        status,
        productLinks
    ]);
    // fetch the data from the bff if required
    (0, $42omo.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hwDTW)))(shortcutsConfig) || isShortcutsStatic || !cloudId) return;
        buildURLAndFetchData();
    }, [
        buildURLAndFetchData,
        cloudId,
        shortcutsConfig,
        isShortcutsStatic
    ]);
    (0, $42omo.useEffect)(()=>{
        if (status === (0, $culkJ.RequestStatus).ERROR && error) onError?.(error);
    }, [
        status,
        error,
        onError
    ]);
    // associate shortcuts with the returned bff data
    const hydratedAppShortcuts = (0, $42omo.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hwDTW)))(shortcutsConfig)) return shortcutsConfig;
        const config = shortcutsConfig;
        if (status === (0, $culkJ.RequestStatus).COMPLETE && Object.keys(productLinks).length) {
            const isArray = Array.isArray(config);
            if (isArray) return config.reduce((acc, item)=>{
                // if config does not need a data reference, just return the value
                if (item.type !== 'link' || !item.apsKey) {
                    acc.push(item);
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[item.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $c124c8c0b6cfb1b3$export$54a1da5292674ec8)(cloudId))[0] : productLink[0];
                    acc.push({
                        ...item,
                        url: filteredProductLink.url
                    });
                }
                return acc;
            }, []);
            const entries = Object.entries(config);
            return entries.reduce((acc, [key, value])=>{
                // if config does not need a data reference, just return the value
                if (value.type !== 'link' || !value.apsKey) {
                    acc[key] = value;
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[value.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $c124c8c0b6cfb1b3$export$54a1da5292674ec8)(cloudId))[0] : productLink[0];
                    acc[key] = {
                        ...value,
                        url: filteredProductLink.url
                    };
                    return acc;
                }
                return acc;
            }, {});
        }
        return shortcutsConfig;
    }, [
        productLinks,
        status,
        shortcutsConfig,
        cloudId
    ]);
    return hydratedAppShortcuts;
};
module.exports["useGlobalShortcutsDataBFF"] = $77ed2a31de36ddab$export$716312c3742c01a3;

});

parcelRegister("b5ZTM", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $ac07a58f3bc8f276$export$26537912ea160acd = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
module.exports["IdContext"] = $ac07a58f3bc8f276$export$26537912ea160acd;

});

parcelRegister("krRQ7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $82b0c4917da0b726$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $42omo.createContext)(false);
module.exports["IsOpenContext"] = $82b0c4917da0b726$export$efa4d9670e96ac31;

});

parcelRegister("aWbCY", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $42omo = parcelRequire("42omo");

const $89af026069549dd5$export$37438ea5f80ca91e = /*#__PURE__*/ (0, $42omo.createContext)({
    current: null
});
module.exports["TriggerRefObjectContext"] = $89af026069549dd5$export$37438ea5f80ca91e;

});

parcelRegister("5NfLM", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $42omo = parcelRequire("42omo");

const $7203d118542dbd32$export$53ee23205ed2541e = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["TriggerRefContext"] = $7203d118542dbd32$export$53ee23205ed2541e;

});

parcelRegister("dfZW8", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b251470ee0db139b$export$2d7d3979eeceb992 = /*#__PURE__*/ (0, $42omo.createContext)(false);
module.exports["EnsureIsInsidePopupContext"] = $b251470ee0db139b$export$2d7d3979eeceb992;

});

parcelRegister("1kcB4", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $42omo = parcelRequire("42omo");

const $1c0070db10e5463c$export$a8c52551eddf6b9 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
module.exports["RoleContext"] = $1c0070db10e5463c$export$a8c52551eddf6b9;

});

parcelRegister("4PRxb", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $0a8295d6b5bfcbf1$export$85b81def7d2cbc37 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
module.exports["SetTriggerRefContext"] = $0a8295d6b5bfcbf1$export$85b81def7d2cbc37;

});

parcelRegister("3T4mU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $dfZW8 = parcelRequire("dfZW8");

function $ca2db23aa6b15bcf$export$421fc1dbb5b2c905() {
    const context = (0, $42omo.useContext)((0, $dfZW8.EnsureIsInsidePopupContext));
    (0, $dRnqM.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
}
module.exports["useEnsureIsInsidePopup"] = $ca2db23aa6b15bcf$export$421fc1dbb5b2c905;

});

parcelRegister("geKgP", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $99893fecde08ccf3$export$c69308b19dea1022 = /*#__PURE__*/ (0, $42omo.createContext)({
    enabled: false
});
const $99893fecde08ccf3$export$b40e2d2385213009 = ({ children: children, enabled: enabled = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99893fecde08ccf3$export$c69308b19dea1022.Provider, {
        value: {
            enabled: enabled
        }
    }, children);
};
module.exports["DragAndDropOptionsContext"] = $99893fecde08ccf3$export$c69308b19dea1022;
module.exports["DragAndDropOptionsProvider"] = $99893fecde08ccf3$export$b40e2d2385213009;

});


//# sourceMappingURL=ConversationAssistant.36a4c013.js.map
